// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { Link } from "react-router-dom";
// import Filter from "../../../Assets/Images/CommanImages/filter.png";
// import columnaddition from "../../../Assets/Images/CommanImages/rectangleplus.png";
// import updown from "../../../Assets/Images/CommanImages/updown.png";
// import searchicon from "../../../Assets/Images/CommanImages/searchyellow.png";
// import leftArrow from "../../../Assets/Images/CommanImages/Larrowbar.png";
// import rightArrow from "../../../Assets/Images/CommanImages/Rarrowbar.png";
// import SelectedValuesDropdown from "../../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
// import FileSaver from "file-saver";
// import * as XLSX from "xlsx";
// import jsPDF from "jspdf";
// import "jspdf-autotable";
// // import "./studentdashboard.css";

// const StudentRegistrationTable = ({
//   headers,
//   data,
//   searchPlaceholder,
//   dataClient,
//   selectedRows,
//   setSelectedRows,
//   bulk = false,
// }) => {
//   const navigate = useNavigate();
//   const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
//   const [isFilterVisible, setIsFilterVisible] = useState(false);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [visibleColumns, setVisibleColumns] = useState([]);
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
//   const [isModalVisible, setIsModalVisible] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);
//   const [averageRunTime, setAverageRunTime] = useState("");
//   const isAllSelected = selectedRows.length === data.length;
//   const columnDropdownRef = useRef(null);

//   const [filters, setFilters] = useState({}); // Holds current selections
//   const [appliedFilters, setAppliedFilters] = useState({});
//   const [isFiltersApplied, setIsFiltersApplied] = useState(false);
//   const [isFilterDropdownSelected, setIsFilterDropdownSelected] = useState(false);


//   useEffect(() => {
//     if (headers.length > 0) {
//       const mustHave = ["Photo", "Roll Number"]; // Lock both Photo and Roll Number
//       const initial = headers
//         .filter(h => !mustHave.includes(h) && h !== "Group ID")
//         .slice(0, 7); // Reduced to 7 since we now have 2 must-have columns
//       const initialWithMustHave = headers.filter(
//         h => (mustHave.includes(h) || initial.includes(h)) && h !== "Group ID"
//       );
//       setVisibleColumns(initialWithMustHave);
//     }
//   }, [headers]);



//   const getStudentInitials = (studentName) => {
//     if (!studentName || studentName === "---") return "NA";
//     const parts = studentName.split(',').map(part => part.trim());

//     if (parts.length === 2) {
//       const lastName = parts[0];
//       const firstName = parts[1];
//       // Return first letter of first name + first letter of last name
//       return (firstName.charAt(0) + lastName.charAt(0)).toUpperCase();
//     }

//     // Fallback: take first two letters or first letter of each word
//     const words = studentName.trim().split(' ');
//     if (words.length >= 2) {
//       return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
//     }

//     // Single word: take first two letters
//     return studentName.substring(0, 2).toUpperCase();
//   };

//   const handleColumnSelection = (column) => {
//     if (["Photo", "Roll Number"].includes(column)) return; // Lock both
//     if (visibleColumns.includes(column)) {
//       setVisibleColumns(visibleColumns.filter(c => c !== column));
//     } else {
//       setVisibleColumns([...visibleColumns, column]);
//     }
//   };


//   const handleSearch = (e) => {
//     setSearchQuery(e.target.value);
//     setCurrentPage(1);
//   };

//   const handleApplyFilter = () => {
//     if (Object.keys(filters).length > 0) {
//       setAppliedFilters({ ...filters }); // Persist selected filters
//       setCurrentPage(1); // Reset to the first page
//       setIsFiltersApplied(true); // Show Reset button
//       setIsFilterVisible(false); // Hide the filter sidebar
//     }
//   };

//   const handleResetFilter = () => {
//     setFilters({}); // Clear current filter selections
//     setAppliedFilters({}); // Clear applied filters
//     setAverageRunTime(""); // Reset any other state if required
//     setIsFiltersApplied(false); // Deactivate the Reset button
//   };

//   const handleFilterSelection = (selectedOption, header) => {
//     setFilters((prevFilters) => ({
//       ...prevFilters,
//       [header]: selectedOption,
//     }));

//     setIsFilterDropdownSelected(true); // Mark dropdown as interacted
//   };

//   const filteredData = data.filter((row) => {
//     const matchesSearchQuery = row.some(
//       (cell) =>
//         cell && String(cell).toLowerCase().includes(searchQuery.toLowerCase())
//     );
//     const matchesAverageRunTime =
//       averageRunTime === "" || row[2] === averageRunTime;

//     // Apply appliedFilters
//     const matchesFilters = Object.entries(appliedFilters).every(
//       ([key, value]) => {
//         const colIndex = headers.indexOf(key);
//         return value ? row[colIndex] === value : true;
//       }
//     );

//     return matchesSearchQuery && matchesAverageRunTime && matchesFilters;
//   });

//   const handleSort = (column) => {
//     let direction = "asc";
//     if (sortConfig.key === column && sortConfig.direction === "asc") {
//       direction = "desc";
//     }
//     setSortConfig({ key: column, direction });
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         columnDropdownRef.current &&
//         !columnDropdownRef.current.contains(event.target)
//       ) {
//         setIsColumnDivVisible(false); // Close the dropdown if clicked outside
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const sortedData = React.useMemo(() => {
//     let sortableData = [...filteredData];
//     if (sortConfig.key !== null) {
//       const colIndex = headers.indexOf(sortConfig.key);
//       sortableData.sort((a, b) => {
//         if (a[colIndex] < b[colIndex]) {
//           return sortConfig.direction === "asc" ? -1 : 1;
//         }
//         if (a[colIndex] > b[colIndex]) {
//           return sortConfig.direction === "asc" ? 1 : -1;
//         }
//         return 0;
//       });
//     }
//     return sortableData;
//   }, [filteredData, sortConfig, headers]);

//   const handleExport = (type) => {
//     const exportData = sortedData.map((row) =>
//       visibleColumns.map((column) => row[headers.indexOf(column)])
//     );

//     const fileName = prompt("Enter the file name:");

//     if (!fileName) {
//       return;
//     }

//     if (type === "excel" || type === "csv") {
//       const worksheet = XLSX.utils.aoa_to_sheet([
//         visibleColumns,
//         ...exportData,
//       ]);
//       const workbook = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

//       const fileExtension = type === "csv" ? "csv" : "xlsx";
//       const mimeType =
//         type === "csv"
//           ? "text/csv"
//           : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

//       const file = XLSX.write(workbook, {
//         bookType: fileExtension,
//         type: "array",
//       });
//       const blob = new Blob([file], { type: mimeType });
//       FileSaver.saveAs(blob, `${fileName}.${fileExtension}`);
//     } else if (type === "pdf") {
//       const doc = new jsPDF();
//       doc.autoTable({
//         head: [visibleColumns],
//         body: exportData,
//       });

//       doc.save(`${fileName}.pdf`);
//     }
//   };

//   const handlePageSizeChange = (size) => {
//     setPageSize(size);
//     setCurrentPage(1);
//   };

//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//   };

//   const totalPages = Math.ceil(sortedData.length / pageSize);
//   const paginatedData = React.useMemo(() => {
//     const startIndex = (currentPage - 1) * pageSize;
//     return sortedData.slice(startIndex, startIndex + pageSize);
//   }, [sortedData, currentPage, pageSize]);

//   const renderPagination = () => {
//     const pages = [];
//     if (totalPages <= 5) {
//       for (let i = 1; i <= totalPages; i++) {
//         pages.push(
//           <button
//             key={i}
//             onClick={() => handlePageChange(i)}
//             style={{ borderRadius: "5px" }}
//             className={i === currentPage ? "active" : ""}
//           >
//             {i}
//           </button>
//         );
//       }
//     } else {
//       if (currentPage <= 3) {
//         for (let i = 1; i <= 3; i++) {
//           pages.push(
//             <button
//               key={i}
//               style={{ borderRadius: "5px" }}
//               onClick={() => handlePageChange(i)}
//               className={i === currentPage ? "active" : ""}
//             >
//               {i}
//             </button>
//           );
//         }
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots1">
//             ...
//           </span>
//         );
//         pages.push(
//           <button
//             key={totalPages}
//             onClick={() => handlePageChange(totalPages)}
//             style={{ borderRadius: "5px" }}
//           >
//             {totalPages}
//           </button>
//         );
//       } else if (currentPage > 3 && currentPage < totalPages - 2) {
//         pages.push(
//           <button
//             key={1}
//             onClick={() => handlePageChange(1)}
//             style={{ borderRadius: "5px" }}
//           >
//             1
//           </button>
//         );
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots1">
//             ...
//           </span>
//         );
//         for (let i = currentPage - 1; i <= currentPage + 1; i++) {
//           pages.push(
//             <button
//               key={i}
//               onClick={() => handlePageChange(i)}
//               style={{ borderRadius: "5px" }}
//               className={i === currentPage ? "active" : ""}
//             >
//               {i}
//             </button>
//           );
//         }
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots2">
//             ...
//           </span>
//         );
//         pages.push(
//           <button
//             key={totalPages}
//             onClick={() => handlePageChange(totalPages)}
//             style={{ borderRadius: "5px" }}
//           >
//             {totalPages}
//           </button>
//         );
//       } else {
//         pages.push(
//           <button
//             key={1}
//             onClick={() => handlePageChange(1)}
//             style={{ borderRadius: "5px" }}
//           >
//             1
//           </button>
//         );
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots1">
//             ...
//           </span>
//         );
//         for (let i = totalPages - 2; i <= totalPages; i++) {
//           pages.push(
//             <button
//               key={i}
//               onClick={() => handlePageChange(i)}
//               style={{ borderRadius: "5px" }}
//               className={i === currentPage ? "active" : ""}
//             >
//               {i}
//             </button>
//           );
//         }
//       }
//     }
//     return pages;
//   };

//   const handleSelectAll = (e) => {
//     if (!bulk) {
//       // If not in bulk mode, don't allow selecting all
//       return;
//     }
//     if (e.target.checked) {
//       setSelectedRows(data.map((row) => row[0]));
//     } else {
//       setSelectedRows([]);
//     }
//   };

//   // Modify handleRowSelect to handle single/multi select
//   const handleRowSelect = (rowIndex) => {
//     const actualIndex = (currentPage - 1) * pageSize + rowIndex;
//     const questionId = data[actualIndex][0];

//     if (bulk) {
//       // Multi-select mode
//       if (selectedRows.includes(questionId)) {
//         setSelectedRows(selectedRows.filter((id) => id !== questionId));
//       } else {
//         setSelectedRows([...selectedRows, questionId]);
//       }
//     } else {
//       // Single-select mode
//       setSelectedRows([questionId]);
//     }
//   };


//   return (
//     <div>
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//           marginTop: "10px",
//         }}
//       >
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             width: "82vw",
//           }}
//         >
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               border: "1px solid #6A6A6A",
//               overflow: "hidden",
//             }}
//           >
//             <input
//               type="text"
//               placeholder={searchPlaceholder}
//               name="search"
//               className="search-input-ques-dash"
//               onChange={handleSearch}
//             />
//             <div
//               style={{
//                 width: "1px",
//                 height: "24px",
//                 backgroundColor: "#2F2E40",
//                 margin: "0 4px",
//               }}
//             ></div>
//             <img
//               src={searchicon}
//               alt="search"
//               className="search-icon-ques-dash"
//             />
//           </div>
//           <div
//             style={{ textAlign: "end", marginTop: "20px", color: "#424242" }}
//           >
//             Displaying{" "}
//             {Math.min((currentPage - 1) * pageSize + 1, sortedData.length)} -{" "}
//             {Math.min(currentPage * pageSize, sortedData.length)} of{" "}
//             {sortedData.length} records |
//             {["10", "25", "50", "100", "500"].map((size) => (
//               <span
//                 key={size}
//                 onClick={() => handlePageSizeChange(Number(size))}
//                 style={{
//                   cursor: "pointer",
//                   margin: "0 5px",
//                   textDecoration:
//                     size === pageSize.toString() ? "none" : "underline",
//                   color: size === pageSize.toString() ? "black" : "#337AB7",
//                 }}
//               >
//                 {size}
//               </span>
//             ))}
//           </div>
//         </div>
//       </div>
//       <div
//         style={{
//           display: "flex",
//           backgroundColor: "#D6D6D6",
//           marginTop: "9px",
//           borderTop: "1px solid grey",
//           borderBottom: "1px solid grey",
//         }}
//       >
//         <div
//           style={{
//             backgroundColor: "#FFBD20",
//             display: "flex",
//             alignItems: "center",
//             cursor: "pointer",
//             paddingLeft: "8px",
//             width: "90px",
//           }}
//           onClick={() => setIsFilterVisible(!isFilterVisible)}
//         >
//           <img
//             src={Filter}
//             style={{ height: "24px", width: "24px" }}
//             alt="filter"
//           />
//           <span style={{ marginLeft: "10px", color: "#2F2E40" }}>Filter</span>
//         </div>
//         <div
//           className="col-tc"
//           style={{
//             marginLeft: "auto",
//             textAlign: "end",
//             marginRight: "8px",
//             display: "flex",
//             alignItems: "center",
//             position: "relative",
//             cursor: "pointer",
//             height: "40px",
//           }}
//           onClick={() => setIsColumnDivVisible(!isColumnDivVisible)}
//         >
//           <img
//             src={columnaddition}
//             style={{ height: "34px", width: "32px" }}
//             alt="column addition"
//           />
//           <span
//             style={{
//               marginLeft: "4px",
//               color: "#2F2E40",
//               marginRight: "14px",
//               fontSize: "14px",
//             }}
//           >
//             Column Selection
//           </span>
//           {isColumnDivVisible && (
//             <div ref={columnDropdownRef}>
//               <div className="arrow-up-tc"></div>
//               <div className="popupColumn-tc">
//                 {headers
//                   .filter(h => h && h !== "Group ID")
//                   .map((column, index) => (
//                     <div key={index} onClick={(e) => { e.stopPropagation(); handleColumnSelection(column); }}>
//                       <input
//                         type="checkbox"
//                         id={`column-${index}`}
//                         value={column}
//                         className="square-checkbox-tc"
//                         checked={visibleColumns.includes(column)}
//                         disabled={column === "Roll Number" || column === "Photo"} // Disable both
//                         readOnly
//                       />
//                       <label htmlFor={`column-${index}`}>{column}</label>
//                     </div>
//                   ))}
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//       {data.length > 0 ? (
//         <>
//           <div className="table-container-scrollable"
//             style={{
//               width: "83vw",
//               overflowX: "auto",
//               overflowY: "visible",
//               WebkitOverflowScrolling: "touch",
//               boxSizing: "border-box"
//             }}
//           >
//             <table className="fixed-header-table" style={{ width: "100%", minWidth: "max-content" }}>
//               <thead>
//                 <tr>
//                   {visibleColumns.map((heading, index) => (
//                     <th
//                       key={index}
//                       className="Heading-tc"
//                       style={{
//                         textAlign: heading === "Photo" ? "center" : "left",
//                         cursor: "pointer",
//                         width: heading === "Photo" ? "80px" : "auto",
//                         padding: heading === "Photo" ? "8px 28px 8px 40px" : "8px 8px", 
//                         whiteSpace: "nowrap"
//                       }}
//                     >
//                       <span
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: heading === "Photo" ? "center" : "left",
//                           color: "rgb(47, 46, 64)",
//                           fontSize: "14px",
//                         }}
//                       >
//                         {heading}
//                         <img
//                           onClick={() => handleSort(heading)}
//                           src={updown}
//                           style={{
//                             height: "20px",
//                             width: "20px",
//                             marginLeft: "5px",
//                           }}
//                           alt="sort"
//                         />
//                       </span>
//                     </th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {paginatedData.map((row, rowIndex) => (
//                   <tr
//                     key={rowIndex}
//                     className={rowIndex % 2 === 1 ? "even-row-tc" : ""}
//                   >
//                     {visibleColumns.map((column, cellIndex) => {
//                       const headerIndex = headers.indexOf(column);
//                       const cellValue = row[headerIndex];

//                       // Photo Column
//                       if (column === "Photo") {
//                         const isValidUrl =
//                           cellValue &&
//                           cellValue !== "---" &&
//                           (cellValue.startsWith("http://") || cellValue.startsWith("https://"));

//                         const nameIndex = headers.indexOf("Name") !== -1
//                           ? headers.indexOf("Name")
//                           : headers.indexOf("Student Name");
//                         const studentName = nameIndex !== -1 ? row[nameIndex] : row[headers.indexOf("Roll Number")];
//                         const initials = getStudentInitials(studentName);

//                         return (
//                           <td
//                             key={cellIndex}
//                             style={{
//                               textAlign: "center",
//                               color: "#6A6A6A",
//                               verticalAlign: "middle",
//                               padding: "6px 8px", // Reduced padding
//                               width: "80px"
//                             }}
//                           >
//                             <div
//                               className="student-avatar-wrapper"
//                               style={{
//                                 display: "flex",
//                                 justifyContent: "center",
//                                 alignItems: "center"
//                               }}
//                             >
//                               {isValidUrl ? (
//                                 <>
//                                   <img
//                                     src={cellValue}
//                                     alt="Student"
//                                     className="student-avatar"
//                                     style={{
//                                       width: "40px", // Reduced from 45px
//                                       height: "40px",
//                                       borderRadius: "50%",
//                                       objectFit: "cover"
//                                     }}
//                                     onError={(e) => {
//                                       e.currentTarget.style.display = "none";
//                                       e.currentTarget.nextSibling.style.display = "flex";
//                                     }}
//                                   />
//                                   <div
//                                     className="student-avatar-placeholder"
//                                     style={{
//                                       display: "none",
//                                       width: "40px",
//                                       height: "40px",
//                                       borderRadius: "50%",
//                                       background: "#e0e0e0",
//                                       justifyContent: "center",
//                                       alignItems: "center",
//                                       fontSize: "13px", // Reduced font
//                                       fontWeight: "600",
//                                       color: "#666"
//                                     }}
//                                   >
//                                     {initials}
//                                   </div>
//                                 </>
//                               ) : (
//                                 <div
//                                   className="student-avatar-placeholder"
//                                   style={{
//                                     width: "40px",
//                                     height: "40px",
//                                     borderRadius: "50%",
//                                     background: "#e0e0e0",
//                                     display: "flex",
//                                     justifyContent: "center",
//                                     alignItems: "center",
//                                     fontSize: "13px",
//                                     fontWeight: "600",
//                                     color: "#666"
//                                   }}
//                                 >
//                                   {initials}
//                                 </div>
//                               )}
//                             </div>
//                           </td>
//                         );
//                       }

//                       // All other columns
//                       return (
//                         <td
//                           key={cellIndex}
//                           style={{
//                             textAlign: "left",
//                             color: "#6A6A6A",
//                             verticalAlign: "middle",
//                             padding: "6px 8px", // Reduced padding from 8px 12px
//                             whiteSpace: "nowrap", // Prevent wrapping to keep compact
//                             overflow: "hidden",
//                             textOverflow: "ellipsis",
//                             maxWidth: "200px" // Add max width for text columns
//                           }}
//                         >
//                           <span title={cellValue}>{cellValue}</span>
//                         </td>
//                       );
//                     })}
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//           <div className="pagination-tc">
//             <button
//               onClick={() => handlePageChange(1)}
//               disabled={currentPage === 1}
//               className="extreme-left-tc-pagination"
//             >
//               <img src={leftArrow} alt="" />
//             </button>
//             <button
//               onClick={() => handlePageChange(currentPage - 1)}
//               disabled={currentPage === 1}
//               className="lefttc-pagination"
//             >
//               {"<"}
//             </button>
//             {renderPagination()}
//             <button
//               onClick={() => handlePageChange(currentPage + 1)}
//               disabled={currentPage === totalPages}
//               className="righttc-pagination"
//             >
//               {">"}
//             </button>
//             <button
//               onClick={() => handlePageChange(totalPages)}
//               disabled={currentPage === totalPages}
//               className="extreme-right-tc-pagination"
//             >
//               <img src={rightArrow} alt="" />
//             </button>
//           </div>
//         </>
//       ) : (
//         "No data available"
//       )}
//       {isFilterVisible && (
//         <div className="filter-sidebar-tc">
//           <div className="filter-content-tc" style={{ position: "relative" }}>
//             <button
//               className="repman-cross-btn-HOD"
//               onClick={() => {
//                 setIsFilterVisible(false);
//               }}
//             >
//               <p>X</p>
//             </button>
//             <h3 className="AdvanceF-heading-tc"> Filter</h3>
//             <div className="filter-apply-reset-ques-rev-dash">
//               <button
//                 className="create-test-section-btn"
//                 onClick={handleApplyFilter}
//               >
//                 APPLY
//               </button>
//               {isFiltersApplied && (
//                 <button
//                   className="create-test-section-btn"
//                   onClick={handleResetFilter}
//                 >
//                   RESET
//                 </button>
//               )}
//             </div>
//             <div className="filter-options-container">
//               {headers
//                 .filter((_, index) => index !== 0)
//                 .map((header, filteredIndex) => {
//                   const originalIndex = filteredIndex + 1;

//                   let uniqueOptions = [
//                     ...new Set(
//                       data
//                         .map((row) => row[originalIndex])
//                         .filter((option) => option)
//                     ),
//                   ];
//                   if (originalIndex === 1 || originalIndex === 6) {
//                     uniqueOptions.sort((a, b) => (a > b ? 1 : -1));
//                   }

//                   return (
//                     <SelectedValuesDropdown
//                       key={originalIndex}
//                       label={header}
//                       width="300px"
//                       marginLeft="15px"
//                       marginTop="18px"
//                       setSelected={(selectedOption) => {
//                         setFilters((prevFilters) => ({
//                           ...prevFilters,
//                           [header]: selectedOption,
//                         }));
//                       }}
//                       options={uniqueOptions.map((value) => ({
//                         label: value,
//                         id: value,
//                       }))}
//                       selected={filters[header] || ""}
//                       Height="auto"
//                       OverFlow="auto"
//                       minheight="200px"
//                     />
//                   );
//                 })}

//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };
// export default StudentRegistrationTable;





















// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { Link } from "react-router-dom";
// import Filter from "../../../Assets/Images/CommanImages/filter.png";
// import columnaddition from "../../../Assets/Images/CommanImages/rectangleplus.png";
// import updown from "../../../Assets/Images/CommanImages/updown.png";
// import searchicon from "../../../Assets/Images/CommanImages/searchyellow.png";
// import leftArrow from "../../../Assets/Images/CommanImages/Larrowbar.png";
// import rightArrow from "../../../Assets/Images/CommanImages/Rarrowbar.png";
// import SelectedValuesDropdown from "../../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
// import FileSaver from "file-saver";
// import * as XLSX from "xlsx";
// import jsPDF from "jspdf";
// import "jspdf-autotable";
// import femaleImg from "../../../Assets/Images/Landing/female_01.png";
// import maleImg from "../../../Assets/Images/Landing/male_01.png";
// // import "./studentdashboard.css";

// const StudentRegistrationTable = ({
//   headers,
//   data,
//   searchPlaceholder,
//   dataClient,
//   selectedRows,
//   setSelectedRows,
//   bulk = false,
// }) => {
//   const navigate = useNavigate();
//   const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
//   const [isFilterVisible, setIsFilterVisible] = useState(false);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [visibleColumns, setVisibleColumns] = useState([]);
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
//   const [isModalVisible, setIsModalVisible] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);
//   const [averageRunTime, setAverageRunTime] = useState("");
//   const isAllSelected = selectedRows.length === data.length;
//   const columnDropdownRef = useRef(null);

//   const [filters, setFilters] = useState({}); // Holds current selections
//   const [appliedFilters, setAppliedFilters] = useState({});
//   const [isFiltersApplied, setIsFiltersApplied] = useState(false);
//   const [isFilterDropdownSelected, setIsFilterDropdownSelected] = useState(false);


//   useEffect(() => {
//     if (headers.length > 0) {
//       const mustHave = ["Photo", "Roll Number"]; // Lock both Photo and Roll Number
//       const initial = headers
//         .filter(h => !mustHave.includes(h) && h !== "Group ID" && h !== "Gender ID")
//         .slice(0, 7); // Reduced to 7 since we now have 2 must-have columns
//       const initialWithMustHave = headers.filter(
//         h => (mustHave.includes(h) || initial.includes(h)) && h !== "Group ID" && h !== "Gender ID"
//       );
//       setVisibleColumns(initialWithMustHave);
//     }
//   }, [headers]);

//   const getGenderAvatar = (originalRow) => {
//     const genderIdIndex = headers.indexOf("Gender ID");
//     const genderId = originalRow[genderIdIndex];
//     return genderId === 1 ? maleImg : femaleImg; // 1 = male, 2/3 = female
//   };

//   const handleColumnSelection = (column) => {
//     if (["Photo", "Roll Number"].includes(column)) return; // Lock both
//     if (visibleColumns.includes(column)) {
//       setVisibleColumns(visibleColumns.filter(c => c !== column));
//     } else {
//       setVisibleColumns([...visibleColumns, column]);
//     }
//   };


//   const handleSearch = (e) => {
//     setSearchQuery(e.target.value);
//     setCurrentPage(1);
//   };

//   const handleApplyFilter = () => {
//     if (Object.keys(filters).length > 0) {
//       setAppliedFilters({ ...filters }); 
//       setCurrentPage(1); 
//       setIsFiltersApplied(true); // Show Reset button
//       setIsFilterVisible(false); // Hide the filter sidebar
//     }
//   };

//   const handleResetFilter = () => {
//     setFilters({}); // Clear current filter selections
//     setAppliedFilters({}); // Clear applied filters
//     setAverageRunTime(""); // Reset any other state if required
//     setIsFiltersApplied(false); // Deactivate the Reset button
//   };

//   const handleFilterSelection = (selectedOption, header) => {
//     setFilters((prevFilters) => ({
//       ...prevFilters,
//       [header]: selectedOption,
//     }));

//     setIsFilterDropdownSelected(true); // Mark dropdown as interacted
//   };

//   const filteredData = data.filter((row) => {
//     const matchesSearchQuery = row.some(
//       (cell) =>
//         cell && String(cell).toLowerCase().includes(searchQuery.toLowerCase())
//     );
//     const matchesAverageRunTime =
//       averageRunTime === "" || row[2] === averageRunTime;

//     // Apply appliedFilters
//     const matchesFilters = Object.entries(appliedFilters).every(
//       ([key, value]) => {
//         const colIndex = headers.indexOf(key);
//         return value ? row[colIndex] === value : true;
//       }
//     );

//     return matchesSearchQuery && matchesAverageRunTime && matchesFilters;
//   });

//   const handleSort = (column) => {
//     let direction = "asc";
//     if (sortConfig.key === column && sortConfig.direction === "asc") {
//       direction = "desc";
//     }
//     setSortConfig({ key: column, direction });
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         columnDropdownRef.current &&
//         !columnDropdownRef.current.contains(event.target)
//       ) {
//         setIsColumnDivVisible(false); // Close the dropdown if clicked outside
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const sortedData = React.useMemo(() => {
//     let sortableData = [...filteredData];
//     if (sortConfig.key !== null) {
//       const colIndex = headers.indexOf(sortConfig.key);
//       sortableData.sort((a, b) => {
//         if (a[colIndex] < b[colIndex]) {
//           return sortConfig.direction === "asc" ? -1 : 1;
//         }
//         if (a[colIndex] > b[colIndex]) {
//           return sortConfig.direction === "asc" ? 1 : -1;
//         }
//         return 0;
//       });
//     }
//     return sortableData;
//   }, [filteredData, sortConfig, headers]);

//   const handleExport = (type) => {
//     const exportData = sortedData.map((row) =>
//       visibleColumns.map((column) => row[headers.indexOf(column)])
//     );

//     const fileName = prompt("Enter the file name:");

//     if (!fileName) {
//       return;
//     }

//     if (type === "excel" || type === "csv") {
//       const worksheet = XLSX.utils.aoa_to_sheet([
//         visibleColumns,
//         ...exportData,
//       ]);
//       const workbook = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

//       const fileExtension = type === "csv" ? "csv" : "xlsx";
//       const mimeType =
//         type === "csv"
//           ? "text/csv"
//           : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

//       const file = XLSX.write(workbook, {
//         bookType: fileExtension,
//         type: "array",
//       });
//       const blob = new Blob([file], { type: mimeType });
//       FileSaver.saveAs(blob, `${fileName}.${fileExtension}`);
//     } else if (type === "pdf") {
//       const doc = new jsPDF();
//       doc.autoTable({
//         head: [visibleColumns],
//         body: exportData,
//       });

//       doc.save(`${fileName}.pdf`);
//     }
//   };

//   const handlePageSizeChange = (size) => {
//     setPageSize(size);
//     setCurrentPage(1);
//   };

//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//   };

//   const totalPages = Math.ceil(sortedData.length / pageSize);
//   const paginatedData = React.useMemo(() => {
//     const startIndex = (currentPage - 1) * pageSize;
//     return sortedData.slice(startIndex, startIndex + pageSize);
//   }, [sortedData, currentPage, pageSize]);

//   const renderPagination = () => {
//     const pages = [];
//     if (totalPages <= 5) {
//       for (let i = 1; i <= totalPages; i++) {
//         pages.push(
//           <button
//             key={i}
//             onClick={() => handlePageChange(i)}
//             style={{ borderRadius: "5px" }}
//             className={i === currentPage ? "active" : ""}
//           >
//             {i}
//           </button>
//         );
//       }
//     } else {
//       if (currentPage <= 3) {
//         for (let i = 1; i <= 3; i++) {
//           pages.push(
//             <button
//               key={i}
//               style={{ borderRadius: "5px" }}
//               onClick={() => handlePageChange(i)}
//               className={i === currentPage ? "active" : ""}
//             >
//               {i}
//             </button>
//           );
//         }
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots1">
//             ...
//           </span>
//         );
//         pages.push(
//           <button
//             key={totalPages}
//             onClick={() => handlePageChange(totalPages)}
//             style={{ borderRadius: "5px" }}
//           >
//             {totalPages}
//           </button>
//         );
//       } else if (currentPage > 3 && currentPage < totalPages - 2) {
//         pages.push(
//           <button
//             key={1}
//             onClick={() => handlePageChange(1)}
//             style={{ borderRadius: "5px" }}
//           >
//             1
//           </button>
//         );
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots1">
//             ...
//           </span>
//         );
//         for (let i = currentPage - 1; i <= currentPage + 1; i++) {
//           pages.push(
//             <button
//               key={i}
//               onClick={() => handlePageChange(i)}
//               style={{ borderRadius: "5px" }}
//               className={i === currentPage ? "active" : ""}
//             >
//               {i}
//             </button>
//           );
//         }
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots2">
//             ...
//           </span>
//         );
//         pages.push(
//           <button
//             key={totalPages}
//             onClick={() => handlePageChange(totalPages)}
//             style={{ borderRadius: "5px" }}
//           >
//             {totalPages}
//           </button>
//         );
//       } else {
//         pages.push(
//           <button
//             key={1}
//             onClick={() => handlePageChange(1)}
//             style={{ borderRadius: "5px" }}
//           >
//             1
//           </button>
//         );
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots1">
//             ...
//           </span>
//         );
//         for (let i = totalPages - 2; i <= totalPages; i++) {
//           pages.push(
//             <button
//               key={i}
//               onClick={() => handlePageChange(i)}
//               style={{ borderRadius: "5px" }}
//               className={i === currentPage ? "active" : ""}
//             >
//               {i}
//             </button>
//           );
//         }
//       }
//     }
//     return pages;
//   };

//   const handleSelectAll = (e) => {
//     if (!bulk) {
//       // If not in bulk mode, don't allow selecting all
//       return;
//     }
//     if (e.target.checked) {
//       setSelectedRows(data.map((row) => row[0]));
//     } else {
//       setSelectedRows([]);
//     }
//   };

//   // Modify handleRowSelect to handle single/multi select
//   const handleRowSelect = (rowIndex) => {
//     const actualIndex = (currentPage - 1) * pageSize + rowIndex;
//     const questionId = data[actualIndex][0];

//     if (bulk) {
//       // Multi-select mode
//       if (selectedRows.includes(questionId)) {
//         setSelectedRows(selectedRows.filter((id) => id !== questionId));
//       } else {
//         setSelectedRows([...selectedRows, questionId]);
//       }
//     } else {
//       // Single-select mode
//       setSelectedRows([questionId]);
//     }
//   };


//   return (
//     <div>
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//           marginTop: "10px",
//         }}
//       >
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             width: "82vw",
//           }}
//         >
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               border: "1px solid #6A6A6A",
//               overflow: "hidden",
//             }}
//           >
//             <input
//               type="text"
//               placeholder={searchPlaceholder}
//               name="search"
//               className="search-input-ques-dash"
//               onChange={handleSearch}
//             />
//             <div
//               style={{
//                 width: "1px",
//                 height: "24px",
//                 backgroundColor: "#2F2E40",
//                 margin: "0 4px",
//               }}
//             ></div>
//             <img
//               src={searchicon}
//               alt="search"
//               className="search-icon-ques-dash"
//             />
//           </div>
//           <div
//             style={{ textAlign: "end", marginTop: "20px", color: "#424242" }}
//           >
//             Displaying{" "}
//             {Math.min((currentPage - 1) * pageSize + 1, sortedData.length)} -{" "}
//             {Math.min(currentPage * pageSize, sortedData.length)} of{" "}
//             {sortedData.length} records |
//             {["10", "25", "50", "100", "500"].map((size) => (
//               <span
//                 key={size}
//                 onClick={() => handlePageSizeChange(Number(size))}
//                 style={{
//                   cursor: "pointer",
//                   margin: "0 5px",
//                   textDecoration:
//                     size === pageSize.toString() ? "none" : "underline",
//                   color: size === pageSize.toString() ? "black" : "#337AB7",
//                 }}
//               >
//                 {size}
//               </span>
//             ))}
//           </div>
//         </div>
//       </div>
//       <div
//         style={{
//           display: "flex",
//           backgroundColor: "#D6D6D6",
//           marginTop: "9px",
//           borderTop: "1px solid grey",
//           borderBottom: "1px solid grey",
//         }}
//       >
//         <div
//           style={{
//             backgroundColor: "#FFBD20",
//             display: "flex",
//             alignItems: "center",
//             cursor: "pointer",
//             paddingLeft: "8px",
//             width: "90px",
//           }}
//           onClick={() => setIsFilterVisible(!isFilterVisible)}
//         >
//           <img
//             src={Filter}
//             style={{ height: "24px", width: "24px" }}
//             alt="filter"
//           />
//           <span style={{ marginLeft: "10px", color: "#2F2E40" }}>Filter</span>
//         </div>
//         <div
//           className="col-tc"
//           style={{
//             marginLeft: "auto",
//             textAlign: "end",
//             marginRight: "8px",
//             display: "flex",
//             alignItems: "center",
//             position: "relative",
//             cursor: "pointer",
//             height: "40px",
//           }}
//           onClick={() => setIsColumnDivVisible(!isColumnDivVisible)}
//         >
//           <img
//             src={columnaddition}
//             style={{ height: "34px", width: "32px" }}
//             alt="column addition"
//           />
//           <span
//             style={{
//               marginLeft: "4px",
//               color: "#2F2E40",
//               marginRight: "14px",
//               fontSize: "14px",
//             }}
//           >
//             Column Selection
//           </span>
//           {isColumnDivVisible && (
//             <div ref={columnDropdownRef}>
//               <div className="arrow-up-tc"></div>
//               <div className="popupColumn-tc">
//                 {headers
//                   .filter(h => h && h !== "Group ID" && h !== "Gender ID")
//                   .map((column, index) => (
//                     <div key={index} onClick={(e) => { e.stopPropagation(); handleColumnSelection(column); }}>
//                       <input
//                         type="checkbox"
//                         id={`column-${index}`}
//                         value={column}
//                         className="square-checkbox-tc"
//                         checked={visibleColumns.includes(column)}
//                         disabled={column === "Roll Number" || column === "Photo"}
//                         readOnly
//                       />
//                       <label htmlFor={`column-${index}`}>{column}</label>
//                     </div>
//                   ))}
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//       {data.length > 0 ? (
//         <>
//           <div className="table-container-scrollable"
//             style={{
//               width: "83vw",
//               overflowX: "auto",
//               overflowY: "visible",
//               WebkitOverflowScrolling: "touch",
//               boxSizing: "border-box"
//             }}
//           >
//             <table className="fixed-header-table" style={{ width: "100%", minWidth: "max-content" }}>
//               <thead>
//                 <tr>
//                   {visibleColumns.map((heading, index) => (
//                     <th
//                       key={index}
//                       className="Heading-tc"
//                       style={{
//                         textAlign: heading === "Photo" ? "center" : "left",
//                         cursor: "pointer",
//                         width: heading === "Photo" ? "80px" : "auto",
//                         padding: heading === "Photo" ? "8px 78px 8px 40px" : "8px 8px",
//                         whiteSpace: "nowrap"
//                       }}
//                     >
//                       <span
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: heading === "Photo" ? "center" : "left",
//                           color: "rgb(47, 46, 64)",
//                           fontSize: "14px",
//                         }}
//                       >
//                         {heading === "Photo" ? null : (
//                           <>
//                             {heading}
//                             <img
//                               onClick={() => handleSort(heading)}
//                               src={updown}
//                               style={{ height: "20px", width: "20px", marginLeft: "5px" }}
//                               alt="sort"
//                             />
//                           </>
//                         )}
//                       </span>
//                     </th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {paginatedData.map((row, rowIndex) => (
//                   <tr
//                     key={rowIndex}
//                     className={rowIndex % 2 === 1 ? "even-row-tc" : ""}
//                   >
//                     {visibleColumns.map((column, cellIndex) => {
//                       const headerIndex = headers.indexOf(column);
//                       const cellValue = row[headerIndex];

//                       // Photo Column
//                       if (column === "Photo") {
//                         const isValidUrl =
//                           cellValue &&
//                           cellValue !== "---" &&
//                           (cellValue.startsWith("http://") || cellValue.startsWith("https://"));

//                         return (
//                           <td
//                             key={cellIndex}
//                             style={{
//                               textAlign: "center",
//                               color: "#6A6A6A",
//                               verticalAlign: "middle",
//                               padding: "6px 8px",
//                               width: "80px"
//                             }}
//                           >
//                             <div
//                               className="student-avatar-wrapper"
//                               style={{
//                                 display: "flex",
//                                 justifyContent: "center",
//                                 alignItems: "center"
//                               }}
//                             >
//                               {isValidUrl ? (
//                                 <>
//                                   <img
//                                     src={cellValue}
//                                     alt="Student"
//                                     className="student-avatar"
//                                     style={{
//                                       width: "40px",
//                                       height: "40px",
//                                       borderRadius: "50%",
//                                       objectFit: "cover"
//                                     }}
//                                     onError={(e) => {
//                                       e.currentTarget.style.display = "none";
//                                       e.currentTarget.nextSibling.style.display = "block";
//                                     }}
//                                   />
//                                   {/* Fallback gender avatar on error */}
//                                   <img
//                                     src={getGenderAvatar(row)}
//                                     alt="Avatar"
//                                     className="student-avatar-placeholder"
//                                     style={{
//                                       display: "none",
//                                       width: "40px",
//                                       height: "40px",
//                                       borderRadius: "50%",
//                                       objectFit: "cover"
//                                     }}
//                                   />
//                                 </>
//                               ) : (
//                                 <img
//                                   src={getGenderAvatar(row)}
//                                   alt="Avatar"
//                                   className="student-avatar-placeholder"
//                                   style={{
//                                     width: "40px",
//                                     height: "40px",
//                                     borderRadius: "50%",
//                                     objectFit: "cover"
//                                   }}
//                                 />
//                               )}
//                             </div>
//                           </td>
//                         );
//                       }
//                       return (
//                         <td
//                           key={cellIndex}
//                           style={{
//                             textAlign: "left",
//                             color: "#6A6A6A",
//                             verticalAlign: "middle",
//                             padding: "6px 8px",
//                             whiteSpace: "nowrap",
//                             overflow: "hidden",
//                             textOverflow: "ellipsis",
//                             maxWidth: "200px"
//                           }}
//                         >
//                           <span title={cellValue}>{cellValue}</span>
//                         </td>
//                       );
//                     })}
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//           <div className="pagination-tc">
//             <button
//               onClick={() => handlePageChange(1)}
//               disabled={currentPage === 1}
//               className="extreme-left-tc-pagination"
//             >
//               <img src={leftArrow} alt="" />
//             </button>
//             <button
//               onClick={() => handlePageChange(currentPage - 1)}
//               disabled={currentPage === 1}
//               className="lefttc-pagination"
//             >
//               {"<"}
//             </button>
//             {renderPagination()}
//             <button
//               onClick={() => handlePageChange(currentPage + 1)}
//               disabled={currentPage === totalPages}
//               className="righttc-pagination"
//             >
//               {">"}
//             </button>
//             <button
//               onClick={() => handlePageChange(totalPages)}
//               disabled={currentPage === totalPages}
//               className="extreme-right-tc-pagination"
//             >
//               <img src={rightArrow} alt="" />
//             </button>
//           </div>
//         </>
//       ) : (
//         "No data available"
//       )}
//       {isFilterVisible && (
//         <div className="filter-sidebar-tc">
//           <div className="filter-content-tc" style={{ position: "relative" }}>
//             <button
//               className="repman-cross-btn-HOD"
//               onClick={() => {
//                 setIsFilterVisible(false);
//               }}
//             >
//               <p>X</p>
//             </button>
//             <h3 className="AdvanceF-heading-tc"> Filter</h3>
//             <div className="filter-apply-reset-ques-rev-dash">
//               <button
//                 className="create-test-section-btn"
//                 onClick={handleApplyFilter}
//               >
//                 APPLY
//               </button>
//               {isFiltersApplied && (
//                 <button
//                   className="create-test-section-btn"
//                   onClick={handleResetFilter}
//                 >
//                   RESET
//                 </button>
//               )}
//             </div>
//             <div className="filter-options-container">
//               {headers
//                 .filter((header, index) => index !== 0 && header !== "Gender ID")
//                 .map((header, filteredIndex) => {
//                   const originalIndex = headers.indexOf(header);

//                   let uniqueOptions = [
//                     ...new Set(
//                       data
//                         .map((row) => row[originalIndex])
//                         .filter((option) => option)
//                     ),
//                   ];
//                   if (originalIndex === 1 || originalIndex === 6) {
//                     uniqueOptions.sort((a, b) => (a > b ? 1 : -1));
//                   }

//                   return (
//                     <SelectedValuesDropdown
//                       key={originalIndex}
//                       label={header}
//                       width="300px"
//                       marginLeft="15px"
//                       marginTop="18px"
//                       setSelected={(selectedOption) => {
//                         setFilters((prevFilters) => ({
//                           ...prevFilters,
//                           [header]: selectedOption,
//                         }));
//                       }}
//                       options={uniqueOptions.map((value) => ({
//                         label: value,
//                         id: value,
//                       }))}
//                       selected={filters[header] || ""}
//                       Height="auto"
//                       OverFlow="auto"
//                       minheight="200px"
//                     />
//                   );
//                 })}

//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };
// export default StudentRegistrationTable;


























// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { Link } from "react-router-dom";
// import Filter from "../../../Assets/Images/CommanImages/filter.png";
// import columnaddition from "../../../Assets/Images/CommanImages/rectangleplus.png";
// import updown from "../../../Assets/Images/CommanImages/updown.png";
// import searchicon from "../../../Assets/Images/CommanImages/searchyellow.png";
// import leftArrow from "../../../Assets/Images/CommanImages/Larrowbar.png";
// import rightArrow from "../../../Assets/Images/CommanImages/Rarrowbar.png";
// import SelectedValuesDropdown from "../../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
// import FileSaver from "file-saver";
// import * as XLSX from "xlsx";
// import jsPDF from "jspdf";
// import "jspdf-autotable";
// // import "./studentdashboard.css";

// const StudentRegistrationTable = ({
//   headers,
//   data,
//   searchPlaceholder,
//   dataClient,
//   selectedRows,
//   setSelectedRows,
//   bulk = false,
// }) => {
//   const navigate = useNavigate();
//   const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
//   const [isFilterVisible, setIsFilterVisible] = useState(false);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [visibleColumns, setVisibleColumns] = useState([]);
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
//   const [isModalVisible, setIsModalVisible] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);
//   const [averageRunTime, setAverageRunTime] = useState("");
//   const isAllSelected = selectedRows.length === data.length;
//   const columnDropdownRef = useRef(null);

//   const [filters, setFilters] = useState({}); // Holds current selections
//   const [appliedFilters, setAppliedFilters] = useState({});
//   const [isFiltersApplied, setIsFiltersApplied] = useState(false);
//   const [isFilterDropdownSelected, setIsFilterDropdownSelected] = useState(false);


//   useEffect(() => {
//     if (headers.length > 0) {
//       const mustHave = ["Photo", "Roll Number"]; // Lock both Photo and Roll Number
//       const initial = headers
//         .filter(h => !mustHave.includes(h) && h !== "Group ID")
//         .slice(0, 7); // Reduced to 7 since we now have 2 must-have columns
//       const initialWithMustHave = headers.filter(
//         h => (mustHave.includes(h) || initial.includes(h)) && h !== "Group ID"
//       );
//       setVisibleColumns(initialWithMustHave);
//     }
//   }, [headers]);



//   const getStudentInitials = (studentName) => {
//     if (!studentName || studentName === "---") return "NA";
//     const parts = studentName.split(',').map(part => part.trim());

//     if (parts.length === 2) {
//       const lastName = parts[0];
//       const firstName = parts[1];
//       // Return first letter of first name + first letter of last name
//       return (firstName.charAt(0) + lastName.charAt(0)).toUpperCase();
//     }

//     // Fallback: take first two letters or first letter of each word
//     const words = studentName.trim().split(' ');
//     if (words.length >= 2) {
//       return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
//     }

//     // Single word: take first two letters
//     return studentName.substring(0, 2).toUpperCase();
//   };

//   const handleColumnSelection = (column) => {
//     if (["Photo", "Roll Number"].includes(column)) return; // Lock both
//     if (visibleColumns.includes(column)) {
//       setVisibleColumns(visibleColumns.filter(c => c !== column));
//     } else {
//       setVisibleColumns([...visibleColumns, column]);
//     }
//   };


//   const handleSearch = (e) => {
//     setSearchQuery(e.target.value);
//     setCurrentPage(1);
//   };

//   const handleApplyFilter = () => {
//     if (Object.keys(filters).length > 0) {
//       setAppliedFilters({ ...filters }); // Persist selected filters
//       setCurrentPage(1); // Reset to the first page
//       setIsFiltersApplied(true); // Show Reset button
//       setIsFilterVisible(false); // Hide the filter sidebar
//     }
//   };

//   const handleResetFilter = () => {
//     setFilters({}); // Clear current filter selections
//     setAppliedFilters({}); // Clear applied filters
//     setAverageRunTime(""); // Reset any other state if required
//     setIsFiltersApplied(false); // Deactivate the Reset button
//   };

//   const handleFilterSelection = (selectedOption, header) => {
//     setFilters((prevFilters) => ({
//       ...prevFilters,
//       [header]: selectedOption,
//     }));

//     setIsFilterDropdownSelected(true); // Mark dropdown as interacted
//   };

//   const filteredData = data.filter((row) => {
//     const matchesSearchQuery = row.some(
//       (cell) =>
//         cell && String(cell).toLowerCase().includes(searchQuery.toLowerCase())
//     );
//     const matchesAverageRunTime =
//       averageRunTime === "" || row[2] === averageRunTime;

//     // Apply appliedFilters
//     const matchesFilters = Object.entries(appliedFilters).every(
//       ([key, value]) => {
//         const colIndex = headers.indexOf(key);
//         return value ? row[colIndex] === value : true;
//       }
//     );

//     return matchesSearchQuery && matchesAverageRunTime && matchesFilters;
//   });

//   const handleSort = (column) => {
//     let direction = "asc";
//     if (sortConfig.key === column && sortConfig.direction === "asc") {
//       direction = "desc";
//     }
//     setSortConfig({ key: column, direction });
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         columnDropdownRef.current &&
//         !columnDropdownRef.current.contains(event.target)
//       ) {
//         setIsColumnDivVisible(false); // Close the dropdown if clicked outside
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const sortedData = React.useMemo(() => {
//     let sortableData = [...filteredData];
//     if (sortConfig.key !== null) {
//       const colIndex = headers.indexOf(sortConfig.key);
//       sortableData.sort((a, b) => {
//         if (a[colIndex] < b[colIndex]) {
//           return sortConfig.direction === "asc" ? -1 : 1;
//         }
//         if (a[colIndex] > b[colIndex]) {
//           return sortConfig.direction === "asc" ? 1 : -1;
//         }
//         return 0;
//       });
//     }
//     return sortableData;
//   }, [filteredData, sortConfig, headers]);

//   const handleExport = (type) => {
//     const exportData = sortedData.map((row) =>
//       visibleColumns.map((column) => row[headers.indexOf(column)])
//     );

//     const fileName = prompt("Enter the file name:");

//     if (!fileName) {
//       return;
//     }

//     if (type === "excel" || type === "csv") {
//       const worksheet = XLSX.utils.aoa_to_sheet([
//         visibleColumns,
//         ...exportData,
//       ]);
//       const workbook = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

//       const fileExtension = type === "csv" ? "csv" : "xlsx";
//       const mimeType =
//         type === "csv"
//           ? "text/csv"
//           : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

//       const file = XLSX.write(workbook, {
//         bookType: fileExtension,
//         type: "array",
//       });
//       const blob = new Blob([file], { type: mimeType });
//       FileSaver.saveAs(blob, `${fileName}.${fileExtension}`);
//     } else if (type === "pdf") {
//       const doc = new jsPDF();
//       doc.autoTable({
//         head: [visibleColumns],
//         body: exportData,
//       });

//       doc.save(`${fileName}.pdf`);
//     }
//   };

//   const handlePageSizeChange = (size) => {
//     setPageSize(size);
//     setCurrentPage(1);
//   };

//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//   };

//   const totalPages = Math.ceil(sortedData.length / pageSize);
//   const paginatedData = React.useMemo(() => {
//     const startIndex = (currentPage - 1) * pageSize;
//     return sortedData.slice(startIndex, startIndex + pageSize);
//   }, [sortedData, currentPage, pageSize]);

//   const renderPagination = () => {
//     const pages = [];
//     if (totalPages <= 5) {
//       for (let i = 1; i <= totalPages; i++) {
//         pages.push(
//           <button
//             key={i}
//             onClick={() => handlePageChange(i)}
//             style={{ borderRadius: "5px" }}
//             className={i === currentPage ? "active" : ""}
//           >
//             {i}
//           </button>
//         );
//       }
//     } else {
//       if (currentPage <= 3) {
//         for (let i = 1; i <= 3; i++) {
//           pages.push(
//             <button
//               key={i}
//               style={{ borderRadius: "5px" }}
//               onClick={() => handlePageChange(i)}
//               className={i === currentPage ? "active" : ""}
//             >
//               {i}
//             </button>
//           );
//         }
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots1">
//             ...
//           </span>
//         );
//         pages.push(
//           <button
//             key={totalPages}
//             onClick={() => handlePageChange(totalPages)}
//             style={{ borderRadius: "5px" }}
//           >
//             {totalPages}
//           </button>
//         );
//       } else if (currentPage > 3 && currentPage < totalPages - 2) {
//         pages.push(
//           <button
//             key={1}
//             onClick={() => handlePageChange(1)}
//             style={{ borderRadius: "5px" }}
//           >
//             1
//           </button>
//         );
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots1">
//             ...
//           </span>
//         );
//         for (let i = currentPage - 1; i <= currentPage + 1; i++) {
//           pages.push(
//             <button
//               key={i}
//               onClick={() => handlePageChange(i)}
//               style={{ borderRadius: "5px" }}
//               className={i === currentPage ? "active" : ""}
//             >
//               {i}
//             </button>
//           );
//         }
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots2">
//             ...
//           </span>
//         );
//         pages.push(
//           <button
//             key={totalPages}
//             onClick={() => handlePageChange(totalPages)}
//             style={{ borderRadius: "5px" }}
//           >
//             {totalPages}
//           </button>
//         );
//       } else {
//         pages.push(
//           <button
//             key={1}
//             onClick={() => handlePageChange(1)}
//             style={{ borderRadius: "5px" }}
//           >
//             1
//           </button>
//         );
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots1">
//             ...
//           </span>
//         );
//         for (let i = totalPages - 2; i <= totalPages; i++) {
//           pages.push(
//             <button
//               key={i}
//               onClick={() => handlePageChange(i)}
//               style={{ borderRadius: "5px" }}
//               className={i === currentPage ? "active" : ""}
//             >
//               {i}
//             </button>
//           );
//         }
//       }
//     }
//     return pages;
//   };

//   const handleSelectAll = (e) => {
//     if (!bulk) {
//       // If not in bulk mode, don't allow selecting all
//       return;
//     }
//     if (e.target.checked) {
//       setSelectedRows(data.map((row) => row[0]));
//     } else {
//       setSelectedRows([]);
//     }
//   };

//   // Modify handleRowSelect to handle single/multi select
//   const handleRowSelect = (rowIndex) => {
//     const actualIndex = (currentPage - 1) * pageSize + rowIndex;
//     const questionId = data[actualIndex][0];

//     if (bulk) {
//       // Multi-select mode
//       if (selectedRows.includes(questionId)) {
//         setSelectedRows(selectedRows.filter((id) => id !== questionId));
//       } else {
//         setSelectedRows([...selectedRows, questionId]);
//       }
//     } else {
//       // Single-select mode
//       setSelectedRows([questionId]);
//     }
//   };


//   return (
//     <div>
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//           marginTop: "10px",
//         }}
//       >
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             width: "82vw",
//           }}
//         >
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               border: "1px solid #6A6A6A",
//               overflow: "hidden",
//             }}
//           >
//             <input
//               type="text"
//               placeholder={searchPlaceholder}
//               name="search"
//               className="search-input-ques-dash"
//               onChange={handleSearch}
//             />
//             <div
//               style={{
//                 width: "1px",
//                 height: "24px",
//                 backgroundColor: "#2F2E40",
//                 margin: "0 4px",
//               }}
//             ></div>
//             <img
//               src={searchicon}
//               alt="search"
//               className="search-icon-ques-dash"
//             />
//           </div>
//           <div
//             style={{ textAlign: "end", marginTop: "20px", color: "#424242" }}
//           >
//             Displaying{" "}
//             {Math.min((currentPage - 1) * pageSize + 1, sortedData.length)} -{" "}
//             {Math.min(currentPage * pageSize, sortedData.length)} of{" "}
//             {sortedData.length} records |
//             {["10", "25", "50", "100", "500"].map((size) => (
//               <span
//                 key={size}
//                 onClick={() => handlePageSizeChange(Number(size))}
//                 style={{
//                   cursor: "pointer",
//                   margin: "0 5px",
//                   textDecoration:
//                     size === pageSize.toString() ? "none" : "underline",
//                   color: size === pageSize.toString() ? "black" : "#337AB7",
//                 }}
//               >
//                 {size}
//               </span>
//             ))}
//           </div>
//         </div>
//       </div>
//       <div
//         style={{
//           display: "flex",
//           backgroundColor: "#D6D6D6",
//           marginTop: "9px",
//           borderTop: "1px solid grey",
//           borderBottom: "1px solid grey",
//         }}
//       >
//         <div
//           style={{
//             backgroundColor: "#FFBD20",
//             display: "flex",
//             alignItems: "center",
//             cursor: "pointer",
//             paddingLeft: "8px",
//             width: "90px",
//           }}
//           onClick={() => setIsFilterVisible(!isFilterVisible)}
//         >
//           <img
//             src={Filter}
//             style={{ height: "24px", width: "24px" }}
//             alt="filter"
//           />
//           <span style={{ marginLeft: "10px", color: "#2F2E40" }}>Filter</span>
//         </div>
//         <div
//           className="col-tc"
//           style={{
//             marginLeft: "auto",
//             textAlign: "end",
//             marginRight: "8px",
//             display: "flex",
//             alignItems: "center",
//             position: "relative",
//             cursor: "pointer",
//             height: "40px",
//           }}
//           onClick={() => setIsColumnDivVisible(!isColumnDivVisible)}
//         >
//           <img
//             src={columnaddition}
//             style={{ height: "34px", width: "32px" }}
//             alt="column addition"
//           />
//           <span
//             style={{
//               marginLeft: "4px",
//               color: "#2F2E40",
//               marginRight: "14px",
//               fontSize: "14px",
//             }}
//           >
//             Column Selection
//           </span>
//           {isColumnDivVisible && (
//             <div ref={columnDropdownRef}>
//               <div className="arrow-up-tc"></div>
//               <div className="popupColumn-tc">
//                 {headers
//                   .filter(h => h && h !== "Group ID")
//                   .map((column, index) => (
//                     <div key={index} onClick={(e) => { e.stopPropagation(); handleColumnSelection(column); }}>
//                       <input
//                         type="checkbox"
//                         id={`column-${index}`}
//                         value={column}
//                         className="square-checkbox-tc"
//                         checked={visibleColumns.includes(column)}
//                         disabled={column === "Roll Number" || column === "Photo"} // Disable both
//                         readOnly
//                       />
//                       <label htmlFor={`column-${index}`}>{column}</label>
//                     </div>
//                   ))}
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//       {data.length > 0 ? (
//         <>
//           <div className="table-container-scrollable"
//             style={{
//               width: "83vw",
//               overflowX: "auto",
//               overflowY: "visible",
//               WebkitOverflowScrolling: "touch",
//               boxSizing: "border-box"
//             }}
//           >
//             <table className="fixed-header-table" style={{ width: "100%", minWidth: "max-content" }}>
//               <thead>
//                 <tr>
//                   {visibleColumns.map((heading, index) => (
//                     <th
//                       key={index}
//                       className="Heading-tc"
//                       style={{
//                         textAlign: heading === "Photo" ? "center" : "left",
//                         cursor: "pointer",
//                         width: heading === "Photo" ? "80px" : "auto",
//                         padding: heading === "Photo" ? "8px 28px 8px 40px" : "8px 8px", 
//                         whiteSpace: "nowrap"
//                       }}
//                     >
//                       <span
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: heading === "Photo" ? "center" : "left",
//                           color: "rgb(47, 46, 64)",
//                           fontSize: "14px",
//                         }}
//                       >
//                         {heading}
//                         <img
//                           onClick={() => handleSort(heading)}
//                           src={updown}
//                           style={{
//                             height: "20px",
//                             width: "20px",
//                             marginLeft: "5px",
//                           }}
//                           alt="sort"
//                         />
//                       </span>
//                     </th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {paginatedData.map((row, rowIndex) => (
//                   <tr
//                     key={rowIndex}
//                     className={rowIndex % 2 === 1 ? "even-row-tc" : ""}
//                   >
//                     {visibleColumns.map((column, cellIndex) => {
//                       const headerIndex = headers.indexOf(column);
//                       const cellValue = row[headerIndex];

//                       // Photo Column
//                       if (column === "Photo") {
//                         const isValidUrl =
//                           cellValue &&
//                           cellValue !== "---" &&
//                           (cellValue.startsWith("http://") || cellValue.startsWith("https://"));

//                         const nameIndex = headers.indexOf("Name") !== -1
//                           ? headers.indexOf("Name")
//                           : headers.indexOf("Student Name");
//                         const studentName = nameIndex !== -1 ? row[nameIndex] : row[headers.indexOf("Roll Number")];
//                         const initials = getStudentInitials(studentName);

//                         return (
//                           <td
//                             key={cellIndex}
//                             style={{
//                               textAlign: "center",
//                               color: "#6A6A6A",
//                               verticalAlign: "middle",
//                               padding: "6px 8px", // Reduced padding
//                               width: "80px"
//                             }}
//                           >
//                             <div
//                               className="student-avatar-wrapper"
//                               style={{
//                                 display: "flex",
//                                 justifyContent: "center",
//                                 alignItems: "center"
//                               }}
//                             >
//                               {isValidUrl ? (
//                                 <>
//                                   <img
//                                     src={cellValue}
//                                     alt="Student"
//                                     className="student-avatar"
//                                     style={{
//                                       width: "40px", // Reduced from 45px
//                                       height: "40px",
//                                       borderRadius: "50%",
//                                       objectFit: "cover"
//                                     }}
//                                     onError={(e) => {
//                                       e.currentTarget.style.display = "none";
//                                       e.currentTarget.nextSibling.style.display = "flex";
//                                     }}
//                                   />
//                                   <div
//                                     className="student-avatar-placeholder"
//                                     style={{
//                                       display: "none",
//                                       width: "40px",
//                                       height: "40px",
//                                       borderRadius: "50%",
//                                       background: "#e0e0e0",
//                                       justifyContent: "center",
//                                       alignItems: "center",
//                                       fontSize: "13px", // Reduced font
//                                       fontWeight: "600",
//                                       color: "#666"
//                                     }}
//                                   >
//                                     {initials}
//                                   </div>
//                                 </>
//                               ) : (
//                                 <div
//                                   className="student-avatar-placeholder"
//                                   style={{
//                                     width: "40px",
//                                     height: "40px",
//                                     borderRadius: "50%",
//                                     background: "#e0e0e0",
//                                     display: "flex",
//                                     justifyContent: "center",
//                                     alignItems: "center",
//                                     fontSize: "13px",
//                                     fontWeight: "600",
//                                     color: "#666"
//                                   }}
//                                 >
//                                   {initials}
//                                 </div>
//                               )}
//                             </div>
//                           </td>
//                         );
//                       }

//                       // All other columns
//                       return (
//                         <td
//                           key={cellIndex}
//                           style={{
//                             textAlign: "left",
//                             color: "#6A6A6A",
//                             verticalAlign: "middle",
//                             padding: "6px 8px", // Reduced padding from 8px 12px
//                             whiteSpace: "nowrap", // Prevent wrapping to keep compact
//                             overflow: "hidden",
//                             textOverflow: "ellipsis",
//                             maxWidth: "200px" // Add max width for text columns
//                           }}
//                         >
//                           <span title={cellValue}>{cellValue}</span>
//                         </td>
//                       );
//                     })}
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//           <div className="pagination-tc">
//             <button
//               onClick={() => handlePageChange(1)}
//               disabled={currentPage === 1}
//               className="extreme-left-tc-pagination"
//             >
//               <img src={leftArrow} alt="" />
//             </button>
//             <button
//               onClick={() => handlePageChange(currentPage - 1)}
//               disabled={currentPage === 1}
//               className="lefttc-pagination"
//             >
//               {"<"}
//             </button>
//             {renderPagination()}
//             <button
//               onClick={() => handlePageChange(currentPage + 1)}
//               disabled={currentPage === totalPages}
//               className="righttc-pagination"
//             >
//               {">"}
//             </button>
//             <button
//               onClick={() => handlePageChange(totalPages)}
//               disabled={currentPage === totalPages}
//               className="extreme-right-tc-pagination"
//             >
//               <img src={rightArrow} alt="" />
//             </button>
//           </div>
//         </>
//       ) : (
//         "No data available"
//       )}
//       {isFilterVisible && (
//         <div className="filter-sidebar-tc">
//           <div className="filter-content-tc" style={{ position: "relative" }}>
//             <button
//               className="repman-cross-btn-HOD"
//               onClick={() => {
//                 setIsFilterVisible(false);
//               }}
//             >
//               <p>X</p>
//             </button>
//             <h3 className="AdvanceF-heading-tc"> Filter</h3>
//             <div className="filter-apply-reset-ques-rev-dash">
//               <button
//                 className="create-test-section-btn"
//                 onClick={handleApplyFilter}
//               >
//                 APPLY
//               </button>
//               {isFiltersApplied && (
//                 <button
//                   className="create-test-section-btn"
//                   onClick={handleResetFilter}
//                 >
//                   RESET
//                 </button>
//               )}
//             </div>
//             <div className="filter-options-container">
//               {headers
//                 .filter((_, index) => index !== 0)
//                 .map((header, filteredIndex) => {
//                   const originalIndex = filteredIndex + 1;

//                   let uniqueOptions = [
//                     ...new Set(
//                       data
//                         .map((row) => row[originalIndex])
//                         .filter((option) => option)
//                     ),
//                   ];
//                   if (originalIndex === 1 || originalIndex === 6) {
//                     uniqueOptions.sort((a, b) => (a > b ? 1 : -1));
//                   }

//                   return (
//                     <SelectedValuesDropdown
//                       key={originalIndex}
//                       label={header}
//                       width="300px"
//                       marginLeft="15px"
//                       marginTop="18px"
//                       setSelected={(selectedOption) => {
//                         setFilters((prevFilters) => ({
//                           ...prevFilters,
//                           [header]: selectedOption,
//                         }));
//                       }}
//                       options={uniqueOptions.map((value) => ({
//                         label: value,
//                         id: value,
//                       }))}
//                       selected={filters[header] || ""}
//                       Height="auto"
//                       OverFlow="auto"
//                       minheight="200px"
//                     />
//                   );
//                 })}

//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };
// export default StudentRegistrationTable;





















// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { Link } from "react-router-dom";
// import Filter from "../../../Assets/Images/CommanImages/filter.png";
// import columnaddition from "../../../Assets/Images/CommanImages/rectangleplus.png";
// import updown from "../../../Assets/Images/CommanImages/updown.png";
// import searchicon from "../../../Assets/Images/CommanImages/searchyellow.png";
// import leftArrow from "../../../Assets/Images/CommanImages/Larrowbar.png";
// import rightArrow from "../../../Assets/Images/CommanImages/Rarrowbar.png";
// import SelectedValuesDropdown from "../../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
// import FileSaver from "file-saver";
// import * as XLSX from "xlsx";
// import jsPDF from "jspdf";
// import "jspdf-autotable";
// import femaleImg from "../../../Assets/Images/Landing/female_01.png";
// import maleImg from "../../../Assets/Images/Landing/male_01.png";
// // import "./studentdashboard.css";

// const StudentRegistrationTable = ({
//   headers,
//   data,
//   searchPlaceholder,
//   dataClient,
//   selectedRows,
//   setSelectedRows,
//   bulk = false,
// }) => {
//   const navigate = useNavigate();
//   const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
//   const [isFilterVisible, setIsFilterVisible] = useState(false);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [visibleColumns, setVisibleColumns] = useState([]);
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
//   const [isModalVisible, setIsModalVisible] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);
//   const [averageRunTime, setAverageRunTime] = useState("");
//   const isAllSelected = selectedRows.length === data.length;
//   const columnDropdownRef = useRef(null);

//   const [filters, setFilters] = useState({}); // Holds current selections
//   const [appliedFilters, setAppliedFilters] = useState({});
//   const [isFiltersApplied, setIsFiltersApplied] = useState(false);
//   const [isFilterDropdownSelected, setIsFilterDropdownSelected] = useState(false);


//   useEffect(() => {
//     if (headers.length > 0) {
//       const mustHave = ["Photo", "Roll Number"]; // Lock both Photo and Roll Number
//       const initial = headers
//         .filter(h => !mustHave.includes(h) && h !== "Group ID" && h !== "Gender ID")
//         .slice(0, 7); // Reduced to 7 since we now have 2 must-have columns
//       const initialWithMustHave = headers.filter(
//         h => (mustHave.includes(h) || initial.includes(h)) && h !== "Group ID" && h !== "Gender ID"
//       );
//       setVisibleColumns(initialWithMustHave);
//     }
//   }, [headers]);

//   const getGenderAvatar = (originalRow) => {
//     const genderIdIndex = headers.indexOf("Gender ID");
//     const genderId = originalRow[genderIdIndex];
//     return genderId === 1 ? maleImg : femaleImg; // 1 = male, 2/3 = female
//   };

//   const handleColumnSelection = (column) => {
//     if (["Photo", "Roll Number"].includes(column)) return; // Lock both
//     if (visibleColumns.includes(column)) {
//       setVisibleColumns(visibleColumns.filter(c => c !== column));
//     } else {
//       setVisibleColumns([...visibleColumns, column]);
//     }
//   };


//   const handleSearch = (e) => {
//     setSearchQuery(e.target.value);
//     setCurrentPage(1);
//   };

//   const handleApplyFilter = () => {
//     if (Object.keys(filters).length > 0) {
//       setAppliedFilters({ ...filters }); 
//       setCurrentPage(1); 
//       setIsFiltersApplied(true); // Show Reset button
//       setIsFilterVisible(false); // Hide the filter sidebar
//     }
//   };

//   const handleResetFilter = () => {
//     setFilters({}); // Clear current filter selections
//     setAppliedFilters({}); // Clear applied filters
//     setAverageRunTime(""); // Reset any other state if required
//     setIsFiltersApplied(false); // Deactivate the Reset button
//   };

//   const handleFilterSelection = (selectedOption, header) => {
//     setFilters((prevFilters) => ({
//       ...prevFilters,
//       [header]: selectedOption,
//     }));

//     setIsFilterDropdownSelected(true); // Mark dropdown as interacted
//   };

//   const filteredData = data.filter((row) => {
//     const matchesSearchQuery = row.some(
//       (cell) =>
//         cell && String(cell).toLowerCase().includes(searchQuery.toLowerCase())
//     );
//     const matchesAverageRunTime =
//       averageRunTime === "" || row[2] === averageRunTime;

//     // Apply appliedFilters
//     const matchesFilters = Object.entries(appliedFilters).every(
//       ([key, value]) => {
//         const colIndex = headers.indexOf(key);
//         return value ? row[colIndex] === value : true;
//       }
//     );

//     return matchesSearchQuery && matchesAverageRunTime && matchesFilters;
//   });

//   const handleSort = (column) => {
//     let direction = "asc";
//     if (sortConfig.key === column && sortConfig.direction === "asc") {
//       direction = "desc";
//     }
//     setSortConfig({ key: column, direction });
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         columnDropdownRef.current &&
//         !columnDropdownRef.current.contains(event.target)
//       ) {
//         setIsColumnDivVisible(false); // Close the dropdown if clicked outside
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const sortedData = React.useMemo(() => {
//     let sortableData = [...filteredData];
//     if (sortConfig.key !== null) {
//       const colIndex = headers.indexOf(sortConfig.key);
//       sortableData.sort((a, b) => {
//         if (a[colIndex] < b[colIndex]) {
//           return sortConfig.direction === "asc" ? -1 : 1;
//         }
//         if (a[colIndex] > b[colIndex]) {
//           return sortConfig.direction === "asc" ? 1 : -1;
//         }
//         return 0;
//       });
//     }
//     return sortableData;
//   }, [filteredData, sortConfig, headers]);

//   const handleExport = (type) => {
//     const exportData = sortedData.map((row) =>
//       visibleColumns.map((column) => row[headers.indexOf(column)])
//     );

//     const fileName = prompt("Enter the file name:");

//     if (!fileName) {
//       return;
//     }

//     if (type === "excel" || type === "csv") {
//       const worksheet = XLSX.utils.aoa_to_sheet([
//         visibleColumns,
//         ...exportData,
//       ]);
//       const workbook = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

//       const fileExtension = type === "csv" ? "csv" : "xlsx";
//       const mimeType =
//         type === "csv"
//           ? "text/csv"
//           : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

//       const file = XLSX.write(workbook, {
//         bookType: fileExtension,
//         type: "array",
//       });
//       const blob = new Blob([file], { type: mimeType });
//       FileSaver.saveAs(blob, `${fileName}.${fileExtension}`);
//     } else if (type === "pdf") {
//       const doc = new jsPDF();
//       doc.autoTable({
//         head: [visibleColumns],
//         body: exportData,
//       });

//       doc.save(`${fileName}.pdf`);
//     }
//   };

//   const handlePageSizeChange = (size) => {
//     setPageSize(size);
//     setCurrentPage(1);
//   };

//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//   };

//   const totalPages = Math.ceil(sortedData.length / pageSize);
//   const paginatedData = React.useMemo(() => {
//     const startIndex = (currentPage - 1) * pageSize;
//     return sortedData.slice(startIndex, startIndex + pageSize);
//   }, [sortedData, currentPage, pageSize]);

//   const renderPagination = () => {
//     const pages = [];
//     if (totalPages <= 5) {
//       for (let i = 1; i <= totalPages; i++) {
//         pages.push(
//           <button
//             key={i}
//             onClick={() => handlePageChange(i)}
//             style={{ borderRadius: "5px" }}
//             className={i === currentPage ? "active" : ""}
//           >
//             {i}
//           </button>
//         );
//       }
//     } else {
//       if (currentPage <= 3) {
//         for (let i = 1; i <= 3; i++) {
//           pages.push(
//             <button
//               key={i}
//               style={{ borderRadius: "5px" }}
//               onClick={() => handlePageChange(i)}
//               className={i === currentPage ? "active" : ""}
//             >
//               {i}
//             </button>
//           );
//         }
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots1">
//             ...
//           </span>
//         );
//         pages.push(
//           <button
//             key={totalPages}
//             onClick={() => handlePageChange(totalPages)}
//             style={{ borderRadius: "5px" }}
//           >
//             {totalPages}
//           </button>
//         );
//       } else if (currentPage > 3 && currentPage < totalPages - 2) {
//         pages.push(
//           <button
//             key={1}
//             onClick={() => handlePageChange(1)}
//             style={{ borderRadius: "5px" }}
//           >
//             1
//           </button>
//         );
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots1">
//             ...
//           </span>
//         );
//         for (let i = currentPage - 1; i <= currentPage + 1; i++) {
//           pages.push(
//             <button
//               key={i}
//               onClick={() => handlePageChange(i)}
//               style={{ borderRadius: "5px" }}
//               className={i === currentPage ? "active" : ""}
//             >
//               {i}
//             </button>
//           );
//         }
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots2">
//             ...
//           </span>
//         );
//         pages.push(
//           <button
//             key={totalPages}
//             onClick={() => handlePageChange(totalPages)}
//             style={{ borderRadius: "5px" }}
//           >
//             {totalPages}
//           </button>
//         );
//       } else {
//         pages.push(
//           <button
//             key={1}
//             onClick={() => handlePageChange(1)}
//             style={{ borderRadius: "5px" }}
//           >
//             1
//           </button>
//         );
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots1">
//             ...
//           </span>
//         );
//         for (let i = totalPages - 2; i <= totalPages; i++) {
//           pages.push(
//             <button
//               key={i}
//               onClick={() => handlePageChange(i)}
//               style={{ borderRadius: "5px" }}
//               className={i === currentPage ? "active" : ""}
//             >
//               {i}
//             </button>
//           );
//         }
//       }
//     }
//     return pages;
//   };

//   const handleSelectAll = (e) => {
//     if (!bulk) {
//       return;
//     }
//     const studentIdIndex = headers.indexOf("Student ID");
//     if (e.target.checked) {
//       setSelectedRows(data.map((row) => studentIdIndex >= 0 ? row[studentIdIndex] : row[18]));
//     } else {
//       setSelectedRows([]);
//     }
//   };

//   // Modify handleRowSelect to handle single/multi select
//   const handleRowSelect = (rowIndex) => {
//     const actualIndex = (currentPage - 1) * pageSize + rowIndex;
//     const row = sortedData[actualIndex];
//     // Use Student ID (index 18) as the unique identifier, not index 0 (Photo URL)
//     const studentIdIndex = headers.indexOf("Student ID");
//     const rowId = studentIdIndex >= 0 ? row[studentIdIndex] : row[18];

//     if (bulk) {
//       // Multi-select mode
//       if (selectedRows.includes(rowId)) {
//         setSelectedRows(selectedRows.filter((id) => id !== rowId));
//       } else {
//         setSelectedRows([...selectedRows, rowId]);
//       }
//     } else {
//       // Single-select mode
//       setSelectedRows([rowId]);
//     }
//   };


//   return (
//     <div>
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//           marginTop: "10px",
//         }}
//       >
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             width: "82vw",
//           }}
//         >
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               border: "1px solid #6A6A6A",
//               overflow: "hidden",
//             }}
//           >
//             <input
//               type="text"
//               placeholder={searchPlaceholder}
//               name="search"
//               className="search-input-ques-dash"
//               onChange={handleSearch}
//             />
//             <div
//               style={{
//                 width: "1px",
//                 height: "24px",
//                 backgroundColor: "#2F2E40",
//                 margin: "0 4px",
//               }}
//             ></div>
//             <img
//               src={searchicon}
//               alt="search"
//               className="search-icon-ques-dash"
//             />
//           </div>
//           <div
//             style={{ textAlign: "end", marginTop: "20px", color: "#424242" }}
//           >
//             Displaying{" "}
//             {Math.min((currentPage - 1) * pageSize + 1, sortedData.length)} -{" "}
//             {Math.min(currentPage * pageSize, sortedData.length)} of{" "}
//             {sortedData.length} records |
//             {["10", "25", "50", "100", "500"].map((size) => (
//               <span
//                 key={size}
//                 onClick={() => handlePageSizeChange(Number(size))}
//                 style={{
//                   cursor: "pointer",
//                   margin: "0 5px",
//                   textDecoration:
//                     size === pageSize.toString() ? "none" : "underline",
//                   color: size === pageSize.toString() ? "black" : "#337AB7",
//                 }}
//               >
//                 {size}
//               </span>
//             ))}
//           </div>
//         </div>
//       </div>
//       <div
//         style={{
//           display: "flex",
//           backgroundColor: "#D6D6D6",
//           marginTop: "9px",
//           borderTop: "1px solid grey",
//           borderBottom: "1px solid grey",
//         }}
//       >
//         <div
//           style={{
//             backgroundColor: "#FFBD20",
//             display: "flex",
//             alignItems: "center",
//             cursor: "pointer",
//             paddingLeft: "8px",
//             width: "90px",
//           }}
//           onClick={() => setIsFilterVisible(!isFilterVisible)}
//         >
//           <img
//             src={Filter}
//             style={{ height: "24px", width: "24px" }}
//             alt="filter"
//           />
//           <span style={{ marginLeft: "10px", color: "#2F2E40" }}>Filter</span>
//         </div>
//         <div
//           className="col-tc"
//           style={{
//             marginLeft: "auto",
//             textAlign: "end",
//             marginRight: "8px",
//             display: "flex",
//             alignItems: "center",
//             position: "relative",
//             cursor: "pointer",
//             height: "40px",
//           }}
//           onClick={() => setIsColumnDivVisible(!isColumnDivVisible)}
//         >
//           <img
//             src={columnaddition}
//             style={{ height: "34px", width: "32px" }}
//             alt="column addition"
//           />
//           <span
//             style={{
//               marginLeft: "4px",
//               color: "#2F2E40",
//               marginRight: "14px",
//               fontSize: "14px",
//             }}
//           >
//             Column Selection
//           </span>
//           {isColumnDivVisible && (
//             <div ref={columnDropdownRef}>
//               <div className="arrow-up-tc"></div>
//               <div className="popupColumn-tc">
//                 {headers
//                   .filter(h => h && h !== "Group ID" && h !== "Gender ID")
//                   .map((column, index) => (
//                     <div key={index} onClick={(e) => { e.stopPropagation(); handleColumnSelection(column); }}>
//                       <input
//                         type="checkbox"
//                         id={`column-${index}`}
//                         value={column}
//                         className="square-checkbox-tc"
//                         checked={visibleColumns.includes(column)}
//                         disabled={column === "Roll Number" || column === "Photo"}
//                         readOnly
//                       />
//                       <label htmlFor={`column-${index}`}>{column}</label>
//                     </div>
//                   ))}
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//       {data.length > 0 ? (
//         <>
//           <div className="table-container-scrollable"
//             style={{
//               width: "83vw",
//               overflowX: "auto",
//               overflowY: "visible",
//               WebkitOverflowScrolling: "touch",
//               boxSizing: "border-box"
//             }}
//           >
//             <table className="fixed-header-table" style={{ width: "100%", minWidth: "max-content" }}>
//               <thead>
//                 <tr>
//                   {/* Checkbox column header - empty, no select-all */}
//                   {bulk && (
//                     <th
//                       className="Heading-tc"
//                       style={{
//                         width: "40px",
//                         padding: "8px",
//                       }}
//                     />
//                   )}
//                   {visibleColumns.map((heading, index) => (
//                     <th
//                       key={index}
//                       className="Heading-tc"
//                       style={{
//                         textAlign: heading === "Photo" ? "center" : "left",
//                         cursor: "pointer",
//                         width: heading === "Photo" ? "80px" : "auto",
//                         padding: heading === "Photo" ? "8px 78px 8px 40px" : "8px 8px",
//                         whiteSpace: "nowrap"
//                       }}
//                     >
//                       <span
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: heading === "Photo" ? "center" : "left",
//                           color: "rgb(47, 46, 64)",
//                           fontSize: "14px",
//                         }}
//                       >
//                         {heading === "Photo" ? null : (
//                           <>
//                             {heading}
//                             <img
//                               onClick={() => handleSort(heading)}
//                               src={updown}
//                               style={{ height: "20px", width: "20px", marginLeft: "5px" }}
//                               alt="sort"
//                             />
//                           </>
//                         )}
//                       </span>
//                     </th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {paginatedData.map((row, rowIndex) => {
//                   // Determine the row's ID (Student ID is at headers index "Student ID")
//                   const studentIdIndex = headers.indexOf("Student ID");
//                   const rowId = studentIdIndex >= 0 ? row[studentIdIndex] : row[18];
//                   const isChecked = selectedRows.includes(rowId);
//                   return (
//                   <tr
//                     key={rowIndex}
//                     className={rowIndex % 2 === 1 ? "even-row-tc" : ""}
//                   >
//                     {/* Checkbox cell */}
//                     {bulk && (
//                       <td
//                         style={{
//                           textAlign: "center",
//                           verticalAlign: "middle",
//                           padding: "6px 8px",
//                           width: "40px",
//                         }}
//                         onClick={(e) => e.stopPropagation()}
//                       >
//                         <input
//                           type="checkbox"
//                           className="square-checkbox-tc"
//                           checked={isChecked}
//                           onChange={() => handleRowSelect(rowIndex)}
//                         />
//                       </td>
//                     )}
//                     {visibleColumns.map((column, cellIndex) => {
//                       const headerIndex = headers.indexOf(column);
//                       const cellValue = row[headerIndex];

//                       // Photo Column
//                       if (column === "Photo") {
//                         const isValidUrl =
//                           cellValue &&
//                           cellValue !== "---" &&
//                           (cellValue.startsWith("http://") || cellValue.startsWith("https://"));

//                         return (
//                           <td
//                             key={cellIndex}
//                             style={{
//                               textAlign: "center",
//                               color: "#6A6A6A",
//                               verticalAlign: "middle",
//                               padding: "6px 8px",
//                               width: "80px"
//                             }}
//                           >
//                             <div
//                               className="student-avatar-wrapper"
//                               style={{
//                                 display: "flex",
//                                 justifyContent: "center",
//                                 alignItems: "center"
//                               }}
//                             >
//                               {isValidUrl ? (
//                                 <>
//                                   <img
//                                     src={cellValue}
//                                     alt="Student"
//                                     className="student-avatar"
//                                     style={{
//                                       width: "40px",
//                                       height: "40px",
//                                       borderRadius: "50%",
//                                       objectFit: "cover"
//                                     }}
//                                     onError={(e) => {
//                                       e.currentTarget.style.display = "none";
//                                       e.currentTarget.nextSibling.style.display = "block";
//                                     }}
//                                   />
//                                   {/* Fallback gender avatar on error */}
//                                   <img
//                                     src={getGenderAvatar(row)}
//                                     alt="Avatar"
//                                     className="student-avatar-placeholder"
//                                     style={{
//                                       display: "none",
//                                       width: "40px",
//                                       height: "40px",
//                                       borderRadius: "50%",
//                                       objectFit: "cover"
//                                     }}
//                                   />
//                                 </>
//                               ) : (
//                                 <img
//                                   src={getGenderAvatar(row)}
//                                   alt="Avatar"
//                                   className="student-avatar-placeholder"
//                                   style={{
//                                     width: "40px",
//                                     height: "40px",
//                                     borderRadius: "50%",
//                                     objectFit: "cover"
//                                   }}
//                                 />
//                               )}
//                             </div>
//                           </td>
//                         );
//                       }
//                       // return (
//                       //   <td
//                       //     key={cellIndex}
//                       //     style={{
//                       //       textAlign: "left",
//                       //       color: "#6A6A6A",
//                       //       verticalAlign: "middle",
//                       //       padding: "6px 8px",
//                       //       whiteSpace: "nowrap",
//                       //       overflow: "hidden",
//                       //       textOverflow: "ellipsis",
//                       //       maxWidth: "200px"
//                       //     }}
//                       //   >
//                       //     <span title={cellValue}>{cellValue}</span>
//                       //   </td>
//                       // );
//                       return (
//                       <td
//                         key={cellIndex}
//                         style={{
//                           textAlign: "left",
//                           color: "#6A6A6A",
//                           verticalAlign: "middle",
//                           padding: "6px 8px",
//                           whiteSpace: "nowrap",
//                           overflow: "hidden",
//                           textOverflow: "ellipsis",
//                           maxWidth: "200px"
//                         }}
//                       >
//                         {column === "Roll Number" ? (
//                           <Link
//                             style={{ 
//                               color: "#337ab7", 
//                               textDecoration: "none",
//                               cursor: "pointer" 
//                             }}
//                              to={`/student_registration_edit?studentId=${encodeURIComponent(row[18])}&rollNumber=${encodeURIComponent(row[1])}`}
//                           >
//                             <span title={cellValue} >
//                               {cellValue}
//                             </span>
//                           </Link>
//                         ) : (
//                           <span title={cellValue}>{cellValue}</span>
//                         )}
//                       </td>
//                     );
//                     })}
//                   </tr>
//                   );
//                 })}
//               </tbody>
//             </table>
//           </div>
//           <div className="pagination-tc">
//             <button
//               onClick={() => handlePageChange(1)}
//               disabled={currentPage === 1}
//               className="extreme-left-tc-pagination"
//             >
//               <img src={leftArrow} alt="" />
//             </button>
//             <button
//               onClick={() => handlePageChange(currentPage - 1)}
//               disabled={currentPage === 1}
//               className="lefttc-pagination"
//             >
//               {"<"}
//             </button>
//             {renderPagination()}
//             <button
//               onClick={() => handlePageChange(currentPage + 1)}
//               disabled={currentPage === totalPages}
//               className="righttc-pagination"
//             >
//               {">"}
//             </button>
//             <button
//               onClick={() => handlePageChange(totalPages)}
//               disabled={currentPage === totalPages}
//               className="extreme-right-tc-pagination"
//             >
//               <img src={rightArrow} alt="" />
//             </button>
//           </div>
//         </>
//       ) : (
//         "No data available"
//       )}
//       {isFilterVisible && (
//         <div className="filter-sidebar-tc">
//           <div className="filter-content-tc" style={{ position: "relative" }}>
//             <button
//               className="repman-cross-btn-HOD"
//               onClick={() => {
//                 setIsFilterVisible(false);
//               }}
//             >
//               <p>X</p>
//             </button>
//             <h3 className="AdvanceF-heading-tc"> Filter</h3>
//             <div className="filter-apply-reset-ques-rev-dash">
//               <button
//                 className="create-test-section-btn"
//                 onClick={handleApplyFilter}
//               >
//                 APPLY
//               </button>
//               {isFiltersApplied && (
//                 <button
//                   className="create-test-section-btn"
//                   onClick={handleResetFilter}
//                 >
//                   RESET
//                 </button>
//               )}
//             </div>
//             <div className="filter-options-container">
//               {headers
//                 .filter((header, index) => index !== 0 && header !== "Gender ID")
//                 .map((header, filteredIndex) => {
//                   const originalIndex = headers.indexOf(header);

//                   let uniqueOptions = [
//                     ...new Set(
//                       data
//                         .map((row) => row[originalIndex])
//                         .filter((option) => option)
//                     ),
//                   ];
//                   if (originalIndex === 1 || originalIndex === 6) {
//                     uniqueOptions.sort((a, b) => (a > b ? 1 : -1));
//                   }

//                   return (
//                     <SelectedValuesDropdown
//                       key={originalIndex}
//                       label={header}
//                       width="300px"
//                       marginLeft="15px"
//                       marginTop="18px"
//                       setSelected={(selectedOption) => {
//                         setFilters((prevFilters) => ({
//                           ...prevFilters,
//                           [header]: selectedOption,
//                         }));
//                       }}
//                       options={uniqueOptions.map((value) => ({
//                         label: value,
//                         id: value,
//                       }))}
//                       selected={filters[header] || ""}
//                       Height="auto"
//                       OverFlow="auto"
//                       minheight="200px"
//                     />
//                   );
//                 })}

//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };
// export default StudentRegistrationTable;






































// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { Link } from "react-router-dom";
// import Filter from "../../../Assets/Images/CommanImages/filter.png";
// import columnaddition from "../../../Assets/Images/CommanImages/rectangleplus.png";
// import updown from "../../../Assets/Images/CommanImages/updown.png";
// import searchicon from "../../../Assets/Images/CommanImages/searchyellow.png";
// import leftArrow from "../../../Assets/Images/CommanImages/Larrowbar.png";
// import rightArrow from "../../../Assets/Images/CommanImages/Rarrowbar.png";
// import SelectedValuesDropdown from "../../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
// import FileSaver from "file-saver";
// import * as XLSX from "xlsx";
// import jsPDF from "jspdf";
// import "jspdf-autotable";
// // import "./studentdashboard.css";

// const StudentRegistrationTable = ({
//   headers,
//   data,
//   searchPlaceholder,
//   dataClient,
//   selectedRows,
//   setSelectedRows,
//   bulk = false,
// }) => {
//   ... (old version 1 - commented out)
// };
// export default StudentRegistrationTable;

// ... (old version 2 - commented out)

// ... (old version 3 - commented out)

// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { Link } from "react-router-dom";
// import Filter from "../../../Assets/Images/CommanImages/filter.png";
// import columnaddition from "../../../Assets/Images/CommanImages/rectangleplus.png";
// import updown from "../../../Assets/Images/CommanImages/updown.png";
// import searchicon from "../../../Assets/Images/CommanImages/searchyellow.png";
// import leftArrow from "../../../Assets/Images/CommanImages/Larrowbar.png";
// import rightArrow from "../../../Assets/Images/CommanImages/Rarrowbar.png";
// import SelectedValuesDropdown from "../../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
// import FileSaver from "file-saver";
// import * as XLSX from "xlsx";
// import jsPDF from "jspdf";
// import "jspdf-autotable";
// // import "./studentdashboard.css";

// const StudentRegistrationTable = ({
//   headers,
//   data,
//   searchPlaceholder,
//   dataClient,
//   selectedRows,
//   setSelectedRows,
//   bulk = false,
// }) => {
//   ... (old version 1 - commented out)
// };
// export default StudentRegistrationTable;

// ... (old version 2 - commented out)

// ... (old version 3 - commented out)














// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { Link } from "react-router-dom";
// import Filter from "../../../Assets/Images/CommanImages/filter.png";
// import columnaddition from "../../../Assets/Images/CommanImages/rectangleplus.png";
// import updown from "../../../Assets/Images/CommanImages/updown.png";
// import searchicon from "../../../Assets/Images/CommanImages/searchyellow.png";
// import leftArrow from "../../../Assets/Images/CommanImages/Larrowbar.png";
// import rightArrow from "../../../Assets/Images/CommanImages/Rarrowbar.png";
// import SelectedValuesDropdown from "../../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
// import FileSaver from "file-saver";
// import * as XLSX from "xlsx";
// import jsPDF from "jspdf";
// import "jspdf-autotable";
// import femaleImg from "../../../Assets/Images/Landing/female_01.png";
// import maleImg from "../../../Assets/Images/Landing/male_01.png";
// // import "./studentdashboard.css";

// const StudentRegistrationTable = ({
//   headers,
//   data,
//   searchPlaceholder,
//   dataClient,
//   selectedRows,
//   setSelectedRows,
//   bulk = false,
// }) => {
//   const navigate = useNavigate();
//   const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
//   const [isFilterVisible, setIsFilterVisible] = useState(false);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [visibleColumns, setVisibleColumns] = useState([]);
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
//   const [isModalVisible, setIsModalVisible] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);
//   const [averageRunTime, setAverageRunTime] = useState("");
//   const isAllSelected = selectedRows.length === data.length;
//   const columnDropdownRef = useRef(null);

//   const [filters, setFilters] = useState({}); // Holds current selections
//   const [appliedFilters, setAppliedFilters] = useState({});
//   const [isFiltersApplied, setIsFiltersApplied] = useState(false);
//   const [isFilterDropdownSelected, setIsFilterDropdownSelected] = useState(false);


//   useEffect(() => {
//     if (headers.length > 0) {
//       const mustHave = ["Photo", "Roll Number"]; // Lock both Photo and Roll Number
//       const initial = headers
//         .filter(h => !mustHave.includes(h) && h !== "Group ID" && h !== "Gender ID")
//         .slice(0, 7); // Reduced to 7 since we now have 2 must-have columns
//       const initialWithMustHave = headers.filter(
//         h => (mustHave.includes(h) || initial.includes(h)) && h !== "Group ID" && h !== "Gender ID"
//       );
//       setVisibleColumns(initialWithMustHave);
//     }
//   }, [headers]);

//   const getGenderAvatar = (originalRow) => {
//     const genderIdIndex = headers.indexOf("Gender ID");
//     const genderId = originalRow[genderIdIndex];
//     return genderId === 1 ? maleImg : femaleImg; // 1 = male, 2/3 = female
//   };

//   const handleColumnSelection = (column) => {
//     if (["Photo", "Roll Number"].includes(column)) return; // Lock both
//     if (visibleColumns.includes(column)) {
//       setVisibleColumns(visibleColumns.filter(c => c !== column));
//     } else {
//       setVisibleColumns([...visibleColumns, column]);
//     }
//   };


//   const handleSearch = (e) => {
//     setSearchQuery(e.target.value);
//     setCurrentPage(1);
//   };

//   const handleApplyFilter = () => {
//     if (Object.keys(filters).length > 0) {
//       setAppliedFilters({ ...filters }); 
//       setCurrentPage(1); 
//       setIsFiltersApplied(true); // Show Reset button
//       setIsFilterVisible(false); // Hide the filter sidebar
//     }
//   };

//   const handleResetFilter = () => {
//     setFilters({}); // Clear current filter selections
//     setAppliedFilters({}); // Clear applied filters
//     setAverageRunTime(""); // Reset any other state if required
//     setIsFiltersApplied(false); // Deactivate the Reset button
//   };

//   const handleFilterSelection = (selectedOption, header) => {
//     setFilters((prevFilters) => ({
//       ...prevFilters,
//       [header]: selectedOption,
//     }));

//     setIsFilterDropdownSelected(true); // Mark dropdown as interacted
//   };

//   const filteredData = data.filter((row) => {
//     const matchesSearchQuery = row.some(
//       (cell) =>
//         cell && String(cell).toLowerCase().includes(searchQuery.toLowerCase())
//     );
//     const matchesAverageRunTime =
//       averageRunTime === "" || row[2] === averageRunTime;

//     // Apply appliedFilters
//     const matchesFilters = Object.entries(appliedFilters).every(
//       ([key, value]) => {
//         const colIndex = headers.indexOf(key);
//         return value ? row[colIndex] === value : true;
//       }
//     );

//     return matchesSearchQuery && matchesAverageRunTime && matchesFilters;
//   });

//   const handleSort = (column) => {
//     let direction = "asc";
//     if (sortConfig.key === column && sortConfig.direction === "asc") {
//       direction = "desc";
//     }
//     setSortConfig({ key: column, direction });
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         columnDropdownRef.current &&
//         !columnDropdownRef.current.contains(event.target)
//       ) {
//         setIsColumnDivVisible(false); // Close the dropdown if clicked outside
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const sortedData = React.useMemo(() => {
//     let sortableData = [...filteredData];
//     if (sortConfig.key !== null) {
//       const colIndex = headers.indexOf(sortConfig.key);
//       sortableData.sort((a, b) => {
//         if (a[colIndex] < b[colIndex]) {
//           return sortConfig.direction === "asc" ? -1 : 1;
//         }
//         if (a[colIndex] > b[colIndex]) {
//           return sortConfig.direction === "asc" ? 1 : -1;
//         }
//         return 0;
//       });
//     }
//     return sortableData;
//   }, [filteredData, sortConfig, headers]);

//   const handleExport = (type) => {
//     const exportData = sortedData.map((row) =>
//       visibleColumns.map((column) => row[headers.indexOf(column)])
//     );

//     const fileName = prompt("Enter the file name:");

//     if (!fileName) {
//       return;
//     }

//     if (type === "excel" || type === "csv") {
//       const worksheet = XLSX.utils.aoa_to_sheet([
//         visibleColumns,
//         ...exportData,
//       ]);
//       const workbook = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

//       const fileExtension = type === "csv" ? "csv" : "xlsx";
//       const mimeType =
//         type === "csv"
//           ? "text/csv"
//           : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

//       const file = XLSX.write(workbook, {
//         bookType: fileExtension,
//         type: "array",
//       });
//       const blob = new Blob([file], { type: mimeType });
//       FileSaver.saveAs(blob, `${fileName}.${fileExtension}`);
//     } else if (type === "pdf") {
//       const doc = new jsPDF();
//       doc.autoTable({
//         head: [visibleColumns],
//         body: exportData,
//       });

//       doc.save(`${fileName}.pdf`);
//     }
//   };

//   const handlePageSizeChange = (size) => {
//     setPageSize(size);
//     setCurrentPage(1);
//   };

//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//   };

//   const totalPages = Math.ceil(sortedData.length / pageSize);
//   const paginatedData = React.useMemo(() => {
//     const startIndex = (currentPage - 1) * pageSize;
//     return sortedData.slice(startIndex, startIndex + pageSize);
//   }, [sortedData, currentPage, pageSize]);

//   const renderPagination = () => {
//     const pages = [];
//     if (totalPages <= 5) {
//       for (let i = 1; i <= totalPages; i++) {
//         pages.push(
//           <button
//             key={i}
//             onClick={() => handlePageChange(i)}
//             style={{ borderRadius: "5px" }}
//             className={i === currentPage ? "active" : ""}
//           >
//             {i}
//           </button>
//         );
//       }
//     } else {
//       if (currentPage <= 3) {
//         for (let i = 1; i <= 3; i++) {
//           pages.push(
//             <button
//               key={i}
//               style={{ borderRadius: "5px" }}
//               onClick={() => handlePageChange(i)}
//               className={i === currentPage ? "active" : ""}
//             >
//               {i}
//             </button>
//           );
//         }
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots1">
//             ...
//           </span>
//         );
//         pages.push(
//           <button
//             key={totalPages}
//             onClick={() => handlePageChange(totalPages)}
//             style={{ borderRadius: "5px" }}
//           >
//             {totalPages}
//           </button>
//         );
//       } else if (currentPage > 3 && currentPage < totalPages - 2) {
//         pages.push(
//           <button
//             key={1}
//             onClick={() => handlePageChange(1)}
//             style={{ borderRadius: "5px" }}
//           >
//             1
//           </button>
//         );
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots1">
//             ...
//           </span>
//         );
//         for (let i = currentPage - 1; i <= currentPage + 1; i++) {
//           pages.push(
//             <button
//               key={i}
//               onClick={() => handlePageChange(i)}
//               style={{ borderRadius: "5px" }}
//               className={i === currentPage ? "active" : ""}
//             >
//               {i}
//             </button>
//           );
//         }
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots2">
//             ...
//           </span>
//         );
//         pages.push(
//           <button
//             key={totalPages}
//             onClick={() => handlePageChange(totalPages)}
//             style={{ borderRadius: "5px" }}
//           >
//             {totalPages}
//           </button>
//         );
//       } else {
//         pages.push(
//           <button
//             key={1}
//             onClick={() => handlePageChange(1)}
//             style={{ borderRadius: "5px" }}
//           >
//             1
//           </button>
//         );
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots1">
//             ...
//           </span>
//         );
//         for (let i = totalPages - 2; i <= totalPages; i++) {
//           pages.push(
//             <button
//               key={i}
//               onClick={() => handlePageChange(i)}
//               style={{ borderRadius: "5px" }}
//               className={i === currentPage ? "active" : ""}
//             >
//               {i}
//             </button>
//           );
//         }
//       }
//     }
//     return pages;
//   };

//   // ── UPDATED: use Student ID (index 18) as the unique row key ──────────────
//   const handleSelectAll = (e) => {
//     if (!bulk) {
//       return;
//     }
//     const studentIdIndex = headers.indexOf("Student ID");
//     if (e.target.checked) {
//       setSelectedRows(data.map((row) => studentIdIndex >= 0 ? row[studentIdIndex] : row[18]));
//     } else {
//       setSelectedRows([]);
//     }
//   };

//   // ── UPDATED: use Student ID (index 18) as the unique row key ──────────────
//   const handleRowSelect = (rowIndex) => {
//     const actualIndex = (currentPage - 1) * pageSize + rowIndex;
//     const row = sortedData[actualIndex];
//     const studentIdIndex = headers.indexOf("Student ID");
//     const rowId = studentIdIndex >= 0 ? row[studentIdIndex] : row[18];

//     if (bulk) {
//       // Multi-select mode
//       if (selectedRows.includes(rowId)) {
//         setSelectedRows(selectedRows.filter((id) => id !== rowId));
//       } else {
//         setSelectedRows([...selectedRows, rowId]);
//       }
//     } else {
//       // Single-select mode
//       setSelectedRows([rowId]);
//     }
//   };


//   return (
//     <div>
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//           marginTop: "10px",
//         }}
//       >
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             width: "82vw",
//           }}
//         >
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               border: "1px solid #6A6A6A",
//               overflow: "hidden",
//             }}
//           >
//             <input
//               type="text"
//               placeholder={searchPlaceholder}
//               name="search"
//               className="search-input-ques-dash"
//               onChange={handleSearch}
//             />
//             <div
//               style={{
//                 width: "1px",
//                 height: "24px",
//                 backgroundColor: "#2F2E40",
//                 margin: "0 4px",
//               }}
//             ></div>
//             <img
//               src={searchicon}
//               alt="search"
//               className="search-icon-ques-dash"
//             />
//           </div>
//           <div
//             style={{ textAlign: "end", marginTop: "20px", color: "#424242" }}
//           >
//             Displaying{" "}
//             {Math.min((currentPage - 1) * pageSize + 1, sortedData.length)} -{" "}
//             {Math.min(currentPage * pageSize, sortedData.length)} of{" "}
//             {sortedData.length} records |
//             {["10", "25", "50", "100", "500"].map((size) => (
//               <span
//                 key={size}
//                 onClick={() => handlePageSizeChange(Number(size))}
//                 style={{
//                   cursor: "pointer",
//                   margin: "0 5px",
//                   textDecoration:
//                     size === pageSize.toString() ? "none" : "underline",
//                   color: size === pageSize.toString() ? "black" : "#337AB7",
//                 }}
//               >
//                 {size}
//               </span>
//             ))}
//           </div>
//         </div>
//       </div>
//       <div
//         style={{
//           display: "flex",
//           backgroundColor: "#D6D6D6",
//           marginTop: "9px",
//           borderTop: "1px solid grey",
//           borderBottom: "1px solid grey",
//         }}
//       >
//         <div
//           style={{
//             backgroundColor: "#FFBD20",
//             display: "flex",
//             alignItems: "center",
//             cursor: "pointer",
//             paddingLeft: "8px",
//             width: "90px",
//           }}
//           onClick={() => setIsFilterVisible(!isFilterVisible)}
//         >
//           <img
//             src={Filter}
//             style={{ height: "24px", width: "24px" }}
//             alt="filter"
//           />
//           <span style={{ marginLeft: "10px", color: "#2F2E40" }}>Filter</span>
//         </div>
//         <div
//           className="col-tc"
//           style={{
//             marginLeft: "auto",
//             textAlign: "end",
//             marginRight: "8px",
//             display: "flex",
//             alignItems: "center",
//             position: "relative",
//             cursor: "pointer",
//             height: "40px",
//           }}
//           onClick={() => setIsColumnDivVisible(!isColumnDivVisible)}
//         >
//           <img
//             src={columnaddition}
//             style={{ height: "34px", width: "32px" }}
//             alt="column addition"
//           />
//           <span
//             style={{
//               marginLeft: "4px",
//               color: "#2F2E40",
//               marginRight: "14px",
//               fontSize: "14px",
//             }}
//           >
//             Column Selection
//           </span>
//           {isColumnDivVisible && (
//             <div ref={columnDropdownRef}>
//               <div className="arrow-up-tc"></div>
//               <div className="popupColumn-tc">
//                 {headers
//                   .filter(h => h && h !== "Group ID" && h !== "Gender ID")
//                   .map((column, index) => (
//                     <div key={index} onClick={(e) => { e.stopPropagation(); handleColumnSelection(column); }}>
//                       <input
//                         type="checkbox"
//                         id={`column-${index}`}
//                         value={column}
//                         className="square-checkbox-tc"
//                         checked={visibleColumns.includes(column)}
//                         disabled={column === "Roll Number" || column === "Photo"}
//                         readOnly
//                       />
//                       <label htmlFor={`column-${index}`}>{column}</label>
//                     </div>
//                   ))}
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//       {data.length > 0 ? (
//         <>
//           <div className="table-container-scrollable"
//             style={{
//               width: "83vw",
//               overflowX: "auto",
//               overflowY: "visible",
//               WebkitOverflowScrolling: "touch",
//               boxSizing: "border-box"
//             }}
//           >
//             <table className="fixed-header-table" style={{ width: "100%", minWidth: "max-content" }}>
//               <thead>
//                 <tr>
//                   {/* ── NEW: empty th for checkbox column – no select-all ── */}
//                   {bulk && (
//                     <th
//                       className="Heading-tc"
//                       style={{ width: "40px", padding: "8px" }}
//                     />
//                   )}
//                   {visibleColumns.map((heading, index) => (
//                     <th
//                       key={index}
//                       className="Heading-tc"
//                       style={{
//                         textAlign: heading === "Photo" ? "center" : "left",
//                         cursor: "pointer",
//                         width: heading === "Photo" ? "80px" : "auto",
//                         padding: heading === "Photo" ? "8px 78px 8px 40px" : "8px 8px",
//                         whiteSpace: "nowrap",
//                         fontWeight: "normal",
//                         color: "#6A6A6A",
//                       }}
//                     >
//                       <span
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: heading === "Photo" ? "center" : "left",
//                           color: "#6A6A6A",
//                           fontSize: "14px",
//                           fontWeight: "normal",
//                         }}
//                       >
//                         {heading === "Photo" ? null : (
//                           <>
//                             {heading}
//                             <img
//                               onClick={() => handleSort(heading)}
//                               src={updown}
//                               style={{ height: "20px", width: "20px", marginLeft: "5px" }}
//                               alt="sort"
//                             />
//                           </>
//                         )}
//                       </span>
//                     </th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {paginatedData.map((row, rowIndex) => {
//                   // ── NEW: resolve Student ID for checkbox state ──
//                   const studentIdIndex = headers.indexOf("Student ID");
//                   const rowId = studentIdIndex >= 0 ? row[studentIdIndex] : row[18];
//                   const isChecked = selectedRows.includes(rowId);
//                   return (
//                     <tr
//                       key={rowIndex}
//                       className={rowIndex % 2 === 1 ? "even-row-tc" : ""}
//                     >
//                       {/* ── NEW: checkbox cell per row ── */}
//                       {bulk && (
//                         <td
//                           style={{
//                             textAlign: "center",
//                             verticalAlign: "middle",
//                             padding: "6px 8px",
//                             width: "40px",
//                           }}
//                           onClick={(e) => e.stopPropagation()}
//                         >
//                           <label style={{ display: "inline-flex", cursor: "pointer", margin: 0 }}>
//                             <input
//                               type="checkbox"
//                               checked={isChecked}
//                               onChange={() => handleRowSelect(rowIndex)}
//                               style={{ display: "none" }}
//                             />
//                             <span style={{
//                               display: "inline-flex",
//                               alignItems: "center",
//                               justifyContent: "center",
//                               width: "16px",
//                               height: "16px",
//                               border: "1.5px solid #9E9E9E",
//                               borderRadius: "2px",
//                               backgroundColor: "#fff",
//                               flexShrink: 0,
//                             }}>
//                               <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg"
//                                 style={{ visibility: isChecked ? "visible" : "hidden" }}>
//                                 <path d="M1 3.5L3.5 6.5L9 1" stroke="#BDBDBD" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
//                               </svg>
//                             </span>
//                           </label>
//                         </td>
//                       )}
//                       {visibleColumns.map((column, cellIndex) => {
//                         const headerIndex = headers.indexOf(column);
//                         const cellValue = row[headerIndex];

//                         // Photo Column
//                         if (column === "Photo") {
//                           const isValidUrl =
//                             cellValue &&
//                             cellValue !== "---" &&
//                             (cellValue.startsWith("http://") || cellValue.startsWith("https://"));

//                           return (
//                             <td
//                               key={cellIndex}
//                               style={{
//                                 textAlign: "center",
//                                 color: "#6A6A6A",
//                                 verticalAlign: "middle",
//                                 padding: "6px 8px",
//                                 width: "80px"
//                               }}
//                             >
//                               <div
//                                 className="student-avatar-wrapper"
//                                 style={{
//                                   display: "flex",
//                                   justifyContent: "center",
//                                   alignItems: "center"
//                                 }}
//                               >
//                                 {isValidUrl ? (
//                                   <>
//                                     <img
//                                       src={cellValue}
//                                       alt="Student"
//                                       className="student-avatar"
//                                       style={{
//                                         width: "40px",
//                                         height: "40px",
//                                         borderRadius: "50%",
//                                         objectFit: "cover"
//                                       }}
//                                       onError={(e) => {
//                                         e.currentTarget.style.display = "none";
//                                         e.currentTarget.nextSibling.style.display = "block";
//                                       }}
//                                     />
//                                     {/* Fallback gender avatar on error */}
//                                     <img
//                                       src={getGenderAvatar(row)}
//                                       alt="Avatar"
//                                       className="student-avatar-placeholder"
//                                       style={{
//                                         display: "none",
//                                         width: "40px",
//                                         height: "40px",
//                                         borderRadius: "50%",
//                                         objectFit: "cover"
//                                       }}
//                                     />
//                                   </>
//                                 ) : (
//                                   <img
//                                     src={getGenderAvatar(row)}
//                                     alt="Avatar"
//                                     className="student-avatar-placeholder"
//                                     style={{
//                                       width: "40px",
//                                       height: "40px",
//                                       borderRadius: "50%",
//                                       objectFit: "cover"
//                                     }}
//                                   />
//                                 )}
//                               </div>
//                             </td>
//                           );
//                         }
//                         return (
//                           <td
//                             key={cellIndex}
//                             style={{
//                               textAlign: "left",
//                               color: "#6A6A6A",
//                               verticalAlign: "middle",
//                               padding: "6px 8px",
//                               whiteSpace: "nowrap",
//                               overflow: "hidden",
//                               textOverflow: "ellipsis",
//                               maxWidth: "200px"
//                             }}
//                           >
//                             {column === "Roll Number" ? (
//                               <Link
//                                 style={{ 
//                                   color: "#337ab7", 
//                                   textDecoration: "none",
//                                   cursor: "pointer" 
//                                 }}
//                                 to={`/student_registration_edit?studentId=${encodeURIComponent(row[18])}&rollNumber=${encodeURIComponent(row[1])}`}
//                               >
//                                 <span title={cellValue}>
//                                   {cellValue}
//                                 </span>
//                               </Link>
//                             ) : (
//                               <span title={cellValue}>{cellValue}</span>
//                             )}
//                           </td>
//                         );
//                       })}
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </table>
//           </div>
//           <div className="pagination-tc">
//             <button
//               onClick={() => handlePageChange(1)}
//               disabled={currentPage === 1}
//               className="extreme-left-tc-pagination"
//             >
//               <img src={leftArrow} alt="" />
//             </button>
//             <button
//               onClick={() => handlePageChange(currentPage - 1)}
//               disabled={currentPage === 1}
//               className="lefttc-pagination"
//             >
//               {"<"}
//             </button>
//             {renderPagination()}
//             <button
//               onClick={() => handlePageChange(currentPage + 1)}
//               disabled={currentPage === totalPages}
//               className="righttc-pagination"
//             >
//               {">"}
//             </button>
//             <button
//               onClick={() => handlePageChange(totalPages)}
//               disabled={currentPage === totalPages}
//               className="extreme-right-tc-pagination"
//             >
//               <img src={rightArrow} alt="" />
//             </button>
//           </div>
//         </>
//       ) : (
//         "No data available"
//       )}
//       {isFilterVisible && (
//         <div className="filter-sidebar-tc">
//           <div className="filter-content-tc" style={{ position: "relative" }}>
//             <button
//               className="repman-cross-btn-HOD"
//               onClick={() => {
//                 setIsFilterVisible(false);
//               }}
//             >
//               <p>X</p>
//             </button>
//             <h3 className="AdvanceF-heading-tc"> Filter</h3>
//             <div className="filter-apply-reset-ques-rev-dash">
//               <button
//                 className="create-test-section-btn"
//                 onClick={handleApplyFilter}
//               >
//                 APPLY
//               </button>
//               {isFiltersApplied && (
//                 <button
//                   className="create-test-section-btn"
//                   onClick={handleResetFilter}
//                 >
//                   RESET
//                 </button>
//               )}
//             </div>
//             <div className="filter-options-container">
//               {headers
//                 .filter((header, index) => index !== 0 && header !== "Gender ID")
//                 .map((header, filteredIndex) => {
//                   const originalIndex = headers.indexOf(header);

//                   let uniqueOptions = [
//                     ...new Set(
//                       data
//                         .map((row) => row[originalIndex])
//                         .filter((option) => option)
//                     ),
//                   ];
//                   if (originalIndex === 1 || originalIndex === 6) {
//                     uniqueOptions.sort((a, b) => (a > b ? 1 : -1));
//                   }

//                   return (
//                     <SelectedValuesDropdown
//                       key={originalIndex}
//                       label={header}
//                       width="300px"
//                       marginLeft="15px"
//                       marginTop="18px"
//                       setSelected={(selectedOption) => {
//                         setFilters((prevFilters) => ({
//                           ...prevFilters,
//                           [header]: selectedOption,
//                         }));
//                       }}
//                       options={uniqueOptions.map((value) => ({
//                         label: value,
//                         id: value,
//                       }))}
//                       selected={filters[header] || ""}
//                       Height="auto"
//                       OverFlow="auto"
//                       minheight="200px"
//                     />
//                   );
//                 })}

//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };
// export default StudentRegistrationTable;












import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Filter from "../../../Assets/Images/CommanImages/filter.png";
import columnaddition from "../../../Assets/Images/CommanImages/rectangleplus.png";
import updown from "../../../Assets/Images/CommanImages/updown.png";
import searchicon from "../../../Assets/Images/CommanImages/searchyellow.png";
import leftArrow from "../../../Assets/Images/CommanImages/Larrowbar.png";
import rightArrow from "../../../Assets/Images/CommanImages/Rarrowbar.png";
import femaleImg from "../../../Assets/Images/Landing/female_01.png";
import maleImg from "../../../Assets/Images/Landing/male_01.png";
import SelectedValuesDropdown from "../../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
import "./studentdashboard.css";

const NON_FILTERABLE = new Set(["Photo", "Gender ID", "Student ID"]);

const HEADER_TO_FILTER_KEY = {
  "Roll Number":            "roll_number",
  "Name":                   "name",
  "Course":                 "course",
  "Batch":                  "batch",
  "Session":                "session",
  "Class Type":             "class_type",
  "Class":                  "class_name",
  "Registration Date":      "reg_date",
  "Status":                 "status",
  "Student Mobile Number":  "student_mobile",
  "Father's Name":          "fathers_name",
  "Father's Mobile Number": "fathers_mobile",
  "Mother's Name":          "mothers_name",
  "Mother's Mobile Number": "mothers_mobile",
  "Emergency Contact":      "emergency_contact",
  "Emergency Number":       "emergency_number",
  "Student App Access":     "student_app_access",
  "Parent App Access":      "parent_app_access",
};

const HEADER_TO_OPTIONS_KEY = {
  "Course":             "courses",
  "Batch":              "batches",
  "Session":            "sessions",
  "Class Type":         "class_types",
  "Class":              "classes",
  "Status":             "statuses",
  "Student App Access": "app_access_options",
  "Parent App Access":  "app_access_options",
};

const LOCKED_COLUMNS = ["Photo", "Roll Number"];

const StudentRegistrationTable = ({
  headers,
  rows,
  total,
  totalPages,
  page,
  pageSize,
  isLoading,
  search,
  onSearchChange,
  onPageChange,
  onPageSizeChange,
  filterOptions,
  pendingFilters,
  setPendingFilters,
  appliedFilters,
  hasAppliedFilters,
  isFilterVisible,
  setIsFilterVisible,
  onApplyFilters,
  onResetFilters,
  selectedRows,
  setSelectedRows,
  bulk,
}) => {
  const [visibleColumns, setVisibleColumns]         = useState([]);
  const [sortConfig, setSortConfig]                 = useState({ key: null, direction: "asc" });
  const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
  const columnDropdownRef                           = useRef(null);

  // ── Initialise visible columns when headers arrive ───────────────────────────
  useEffect(() => {
    if (headers.length === 0) return;
    const hidden  = new Set(["Gender ID", "Student ID"]);
    const initial = headers
      .filter((h) => LOCKED_COLUMNS.includes(h) || !hidden.has(h))
      .slice(0, 9);
    LOCKED_COLUMNS.forEach((l) => {
      if (headers.includes(l) && !initial.includes(l)) initial.unshift(l);
    });
    setVisibleColumns(initial);
  }, [headers]);

  // ── Close column dropdown on outside click ────────────────────────────────────
  useEffect(() => {
    const handler = (e) => {
      if (columnDropdownRef.current && !columnDropdownRef.current.contains(e.target)) {
        setIsColumnDivVisible(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  // ── Column toggle ─────────────────────────────────────────────────────────────
  const handleColumnSelection = (col) => {
    if (LOCKED_COLUMNS.includes(col)) return;
    setVisibleColumns((prev) =>
      prev.includes(col) ? prev.filter((c) => c !== col) : [...prev, col]
    );
  };

  // ── Client-side sort on current page ─────────────────────────────────────────
  const sortedRows = React.useMemo(() => {
    if (!sortConfig.key) return rows;
    const idx = headers.indexOf(sortConfig.key);
    if (idx === -1) return rows;
    return [...rows].sort((a, b) => {
      const av = a[idx] ?? "";
      const bv = b[idx] ?? "";
      if (av < bv) return sortConfig.direction === "asc" ? -1 : 1;
      if (av > bv) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
  }, [rows, sortConfig, headers]);

  const handleSort = (col) => {
    setSortConfig((prev) =>
      prev.key === col
        ? { key: col, direction: prev.direction === "asc" ? "desc" : "asc" }
        : { key: col, direction: "asc" }
    );
  };

  // ── Row selection ─────────────────────────────────────────────────────────────
  const studentIdIdx = headers.indexOf("Student ID");
  const getRowId     = (row) => row[studentIdIdx !== -1 ? studentIdIdx : 18];

  const handleRowSelect = (row) => {
    const id = getRowId(row);
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((r) => r !== id) : [...prev, id]
    );
  };

  // ── Gender avatar ─────────────────────────────────────────────────────────────
  const genderIdx = headers.indexOf("Gender ID");
  const getAvatar = (row) => (row[genderIdx] === 1 ? maleImg : femaleImg);

  // ── Pagination buttons ────────────────────────────────────────────────────────
  const renderPagination = () => {
    const pages = [];
    const addBtn = (i) =>
      pages.push(
        <button
          key={i}
          onClick={() => onPageChange(i)}
          style={{ borderRadius: "5px" }}
          className={i === page ? "active" : ""}
        >
          {i}
        </button>
      );
    const addDots = (key) =>
      pages.push(<span key={key} style={{ borderRadius: "5px" }}>...</span>);

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) addBtn(i);
    } else if (page <= 3) {
      for (let i = 1; i <= 3; i++) addBtn(i);
      addDots("d1");
      addBtn(totalPages);
    } else if (page >= totalPages - 2) {
      addBtn(1);
      addDots("d1");
      for (let i = totalPages - 2; i <= totalPages; i++) addBtn(i);
    } else {
      addBtn(1);
      addDots("d1");
      for (let i = page - 1; i <= page + 1; i++) addBtn(i);
      addDots("d2");
      addBtn(totalPages);
    }
    return pages;
  };

  // ── Filter input renderer ─────────────────────────────────────────────────────
  // Shared style constants matching SelectedValuesDropdown's dropdown-btn exactly
  const FILTER_WIDTH  = "300px";
  const FILTER_MARGIN = "15px";

  const labelStyle = {
    fontFamily: "'ABeeZee', sans-serif",
    fontSize:   "14px",
    color:      "#424342",
    fontWeight: 400,
    lineHeight: "14px",
  };

  const textInputStyle = {
    display:         "block",
    width:           FILTER_WIDTH,
    height:          "32px",
    padding:         "10px",
    margin:          "6px 0px",
    border:          "1px solid gray",
    backgroundColor: "#ffffff",
    color:           "#6a6a6a",
    fontFamily:      "Arial",
    fontSize:        "14px",
    fontWeight:      400,
    outline:         "none",
    boxSizing:       "border-box",
  };

  const renderFilterInput = (header) => {
    if (NON_FILTERABLE.has(header)) return null;
    if (!HEADER_TO_FILTER_KEY[header]) return null;

    const filterKey = HEADER_TO_FILTER_KEY[header];

    // Date range — two date inputs
    if (filterOptions?.date_range_fields?.includes(header)) {
      return (
        <div key={header} style={{ marginLeft: FILTER_MARGIN, marginTop: "18px" }}>
          <label style={labelStyle}>{header}</label>
          <div style={{ display: "flex", gap: "8px", alignItems: "center", margin: "6px 0px" }}>
            <input
              type="date"
              value={pendingFilters["reg_date_from"] || ""}
              onChange={(e) =>
                setPendingFilters((prev) => ({ ...prev, reg_date_from: e.target.value }))
              }
              style={{ ...textInputStyle, width: "142px", margin: 0 }}
            />
            <span style={{ color: "#6A6A6A", fontSize: "12px" }}>to</span>
            <input
              type="date"
              value={pendingFilters["reg_date_to"] || ""}
              onChange={(e) =>
                setPendingFilters((prev) => ({ ...prev, reg_date_to: e.target.value }))
              }
              style={{ ...textInputStyle, width: "142px", margin: 0 }}
            />
          </div>
        </div>
      );
    }

    // Free-text search input — matches dropdown-btn dimensions exactly
    if (filterOptions?.search_input_fields?.includes(header)) {
      return (
        <div key={header} style={{ marginLeft: FILTER_MARGIN, marginTop: "18px" }}>
          <label style={labelStyle}>{header}</label>
          <input
            type="text"
            placeholder="Search..."
            value={pendingFilters[filterKey] || ""}
            onChange={(e) =>
              setPendingFilters((prev) => ({ ...prev, [filterKey]: e.target.value }))
            }
            style={textInputStyle}
          />
        </div>
      );
    }

    // Dropdown — SelectedValuesDropdown component
    const optionsKey = HEADER_TO_OPTIONS_KEY[header];
    const options    = filterOptions?.[optionsKey] || [];
    return (
      <SelectedValuesDropdown
        key={header}
        label={header}
        width={FILTER_WIDTH}
        marginLeft={FILTER_MARGIN}
        marginTop="18px"
        selected={pendingFilters[filterKey] || ""}
        setSelected={(val) =>
          setPendingFilters((prev) => ({ ...prev, [filterKey]: val }))
        }
        options={options.map((opt) => ({ label: opt, id: opt }))}
        Height="auto"
        OverFlow="auto"
        minheight="200px"
      />
    );
  };

  const firstRow = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const lastRow  = Math.min(page * pageSize, total);

  return (
    <div>
      {/* ── Top bar: search + record count + page size ─────────────────────── */}
      <div
        style={{
          display:        "flex",
          alignItems:     "center",
          justifyContent: "space-between",
          width:          "82vw",
          marginTop:      "10px",
        }}
      >
        <div
          style={{
            display:    "flex",
            alignItems: "center",
            border:     "1px solid #6A6A6A",
            overflow:   "hidden",
          }}
        >
          <input
            type="text"
            placeholder="Filter Student Groups..."
            value={search}
            onChange={onSearchChange}
            className="search-input-ques-dash"
          />
          <div style={{ width: "1px", height: "24px", backgroundColor: "#2F2E40", margin: "0 4px" }} />
          <img src={searchicon} alt="search" className="search-icon-ques-dash" />
        </div>

        <div style={{ textAlign: "end", color: "#424242" }}>
          {isLoading ? (
            <span style={{ color: "#FFBD20" }}>Loading...</span>
          ) : (
            <>
              Displaying {firstRow}–{lastRow} of {total} records |{" "}
              {[10, 25, 50, 100, 500].map((size) => (
                <span
                  key={size}
                  onClick={() => onPageSizeChange(size)}
                  style={{
                    cursor:         "pointer",
                    margin:         "0 5px",
                    textDecoration: size === pageSize ? "none" : "underline",
                    color:          size === pageSize ? "black" : "#337AB7",
                    fontWeight:     size === pageSize ? "600" : "normal",
                  }}
                >
                  {size}
                </span>
              ))}
            </>
          )}
        </div>
      </div>

      {/* ── Filter + Column selection bar ───────────────────────────────────── */}
      <div
        style={{
          display:         "flex",
          backgroundColor: "#D6D6D6",
          marginTop:       "9px",
          borderTop:       "1px solid grey",
          borderBottom:    "1px solid grey",
        }}
      >
        {/* Filter button — always yellow */}
        <div
          style={{
            backgroundColor: "#FFBD20",
            display:         "flex",
            alignItems:      "center",
            cursor:          "pointer",
            paddingLeft:     "8px",
            width:           "90px",
          }}
          onClick={() => {
            setPendingFilters({ ...appliedFilters });
            setIsFilterVisible(!isFilterVisible);
          }}
        >
          <img src={Filter} style={{ height: "24px", width: "24px" }} alt="filter" />
          <span style={{ marginLeft: "10px", color: "#2F2E40" }}>Filter</span>
        </div>

        {/* Column selection */}
        <div
          className="col-tc"
          style={{
            marginLeft: "auto",
            marginRight: "8px",
            display:    "flex",
            alignItems: "center",
            position:   "relative",
            cursor:     "pointer",
            height:     "40px",
          }}
          onClick={() => setIsColumnDivVisible(!isColumnDivVisible)}
        >
          <img src={columnaddition} style={{ height: "34px", width: "32px" }} alt="column addition" />
          <span style={{ marginLeft: "4px", color: "#2F2E40", marginRight: "14px", fontSize: "14px" }}>
            Column Selection
          </span>
          {isColumnDivVisible && (
            <div ref={columnDropdownRef}>
              <div className="arrow-up-tc" />
              <div className="popupColumn-tc">
                {headers
                  .filter((h) => h && h !== "Gender ID")
                  .map((col, i) => (
                    <div
                      key={i}
                      onClick={(e) => { e.stopPropagation(); handleColumnSelection(col); }}
                    >
                      <input
                        type="checkbox"
                        className="square-checkbox-tc"
                        checked={visibleColumns.includes(col)}
                        disabled={LOCKED_COLUMNS.includes(col)}
                        readOnly
                      />
                      <label style={{ marginLeft: "6px", fontSize: "13px" }}>{col}</label>
                    </div>
                  ))}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* ── Table ───────────────────────────────────────────────────────────── */}
      {rows.length === 0 && !isLoading ? (
        <div style={{ padding: "40px", textAlign: "center", color: "#6A6A6A" }}>
          No students found.
        </div>
      ) : (
        <>
          <div
            className="table-container-scrollable"
            style={{
              width:                   "83vw",
              overflowX:               "auto",
              overflowY:               "visible",
              WebkitOverflowScrolling: "touch",
              boxSizing:               "border-box",
            }}
          >
            <table className="fixed-header-table" style={{ width: "100%", minWidth: "max-content" }}>
              <thead>
                <tr>
                  {bulk && <th className="Heading-tc" style={{ width: "40px", padding: "8px" }} />}
                  {visibleColumns.map((heading, i) => (
                    <th
                      key={i}
                      className="Heading-tc"
                      style={{
                        textAlign:  heading === "Photo" ? "center" : "left",
                        cursor:     "pointer",
                        width:      heading === "Photo" ? "80px" : "auto",
                        padding:    heading === "Photo" ? "8px 28px" : "8px",
                        whiteSpace: "nowrap",
                        fontWeight: "normal",
                        color:      "#6A6A6A",
                      }}
                    >
                      <span
                        style={{
                          display:        "flex",
                          alignItems:     "center",
                          justifyContent: heading === "Photo" ? "center" : "left",
                          color:          "#6A6A6A",
                          fontSize:       "14px",
                        }}
                      >
                        {heading === "Photo" ? null : (
                          <>
                            {heading}
                            <img
                              onClick={() => handleSort(heading)}
                              src={updown}
                              style={{ height: "20px", width: "20px", marginLeft: "5px" }}
                              alt="sort"
                            />
                          </>
                        )}
                      </span>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {sortedRows.map((row, rowIdx) => {
                  const rowId     = getRowId(row);
                  const isChecked = selectedRows.includes(rowId);
                  return (
                    <tr key={rowIdx} className={rowIdx % 2 === 1 ? "even-row-tc" : ""}>
                      {bulk && (
                        <td
                          style={{
                            textAlign:      "center",
                            verticalAlign:  "middle",
                            padding:        "6px 8px",
                            width:          "40px",
                          }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <label style={{ display: "inline-flex", cursor: "pointer", margin: 0 }}>
                            <input
                              type="checkbox"
                              checked={isChecked}
                              onChange={() => handleRowSelect(row)}
                              style={{ display: "none" }}
                            />
                            <span
                              style={{
                                display:         "inline-flex",
                                alignItems:      "center",
                                justifyContent:  "center",
                                width:           "16px",
                                height:          "16px",
                                border:          "1.5px solid #9E9E9E",
                                borderRadius:    "2px",
                                backgroundColor: "#fff",
                                flexShrink:      0,
                              }}
                            >
                              <svg
                                width="10" height="8" viewBox="0 0 10 8"
                                fill="none" xmlns="http://www.w3.org/2000/svg"
                                style={{ visibility: isChecked ? "visible" : "hidden" }}
                              >
                                <path
                                  d="M1 3.5L3.5 6.5L9 1"
                                  stroke="#BDBDBD"
                                  strokeWidth="1.8"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </span>
                          </label>
                        </td>
                      )}

                      {visibleColumns.map((col, ci) => {
                        const hi      = headers.indexOf(col);
                        const val     = hi !== -1 ? row[hi] : null;
                        const display = val === null || val === undefined || val === "" ? "---" : val;

                        // Photo column
                        if (col === "Photo") {
                          const isValidUrl =
                            val &&
                            val !== "---" &&
                            (val.startsWith("http://") || val.startsWith("https://"));
                          return (
                            <td
                              key={ci}
                              style={{
                                textAlign:     "center",
                                verticalAlign: "middle",
                                padding:       "6px 8px",
                                width:         "80px",
                              }}
                            >
                              <div
                                className="student-avatar-wrapper"
                                style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
                              >
                                {isValidUrl ? (
                                  <>
                                    <img
                                      src={val}
                                      alt="Student"
                                      className="student-avatar"
                                      style={{ width: "40px", height: "40px", borderRadius: "50%", objectFit: "cover" }}
                                      onError={(e) => {
                                        e.currentTarget.style.display = "none";
                                        e.currentTarget.nextSibling.style.display = "block";
                                      }}
                                    />
                                    <img
                                      src={getAvatar(row)}
                                      alt="Avatar"
                                      className="student-avatar-placeholder"
                                      style={{ display: "none", width: "40px", height: "40px", borderRadius: "50%", objectFit: "cover" }}
                                    />
                                  </>
                                ) : (
                                  <img
                                    src={getAvatar(row)}
                                    alt="Avatar"
                                    className="student-avatar-placeholder"
                                    style={{ width: "40px", height: "40px", borderRadius: "50%", objectFit: "cover" }}
                                  />
                                )}
                              </div>
                            </td>
                          );
                        }

                        // Roll Number — link to edit
                        if (col === "Roll Number") {
                          const sidIdx = headers.indexOf("Student ID");
                          const sid    = sidIdx !== -1 ? row[sidIdx] : row[18];
                          return (
                            <td
                              key={ci}
                              style={{ padding: "6px 8px", whiteSpace: "nowrap", verticalAlign: "middle" }}
                            >
                              <Link
                                to={`/student_registration_edit?studentId=${encodeURIComponent(sid)}&rollNumber=${encodeURIComponent(val || "")}`}
                                style={{ color: "#337ab7", textDecoration: "none", cursor: "pointer" }}
                              >
                                <span title={display}>{display}</span>
                              </Link>
                            </td>
                          );
                        }

                        // All other columns
                        return (
                          <td
                            key={ci}
                            style={{
                              textAlign:     "left",
                              color:         "#6A6A6A",
                              verticalAlign: "middle",
                              padding:       "6px 8px",
                              whiteSpace:    "nowrap",
                              overflow:      "hidden",
                              textOverflow:  "ellipsis",
                              maxWidth:      "200px",
                            }}
                          >
                            <span title={display}>{display}</span>
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          {/* ── Pagination ─────────────────────────────────────────────────── */}
          <div className="pagination-tc">
            <button
              onClick={() => onPageChange(1)}
              disabled={page === 1}
              className="extreme-left-tc-pagination"
            >
              <img src={leftArrow} alt="" />
            </button>
            <button
              onClick={() => onPageChange(page - 1)}
              disabled={page === 1}
              className="lefttc-pagination"
            >
              {"<"}
            </button>
            {renderPagination()}
            <button
              onClick={() => onPageChange(page + 1)}
              disabled={page === totalPages}
              className="righttc-pagination"
            >
              {">"}
            </button>
            <button
              onClick={() => onPageChange(totalPages)}
              disabled={page === totalPages}
              className="extreme-right-tc-pagination"
            >
              <img src={rightArrow} alt="" />
            </button>
          </div>
        </>
      )}

      {/* ── Filter sidebar ──────────────────────────────────────────────────── */}
      {isFilterVisible && (
        <div className="filter-sidebar-tc">
          <div className="filter-content-tc" style={{ position: "relative" }}>

            {/* Cross button — sits outside left edge */}
            <button
              className="repman-cross-btn-HOD"
              onClick={() => setIsFilterVisible(false)}
            >
              <p>X</p>
            </button>

            {/* Yellow header */}
            <h3 className="AdvanceF-heading-tc">Filter</h3>

            {/* Apply / Reset — aligned to input edges */}
            <div
              style={{
                display:        "flex",
                justifyContent: "space-between",
                alignItems:     "center",
                // marginLeft:     FILTER_MARGIN,
                marginTop:      "10px",
                width:          FILTER_WIDTH,
              }}
            >
              <button className="create-test-section-btn" onClick={onApplyFilters}>
                APPLY
              </button>
              {hasAppliedFilters && (
                <button style={{marginRight:"0px"}} className="create-test-section-btn" onClick={onResetFilters}>
                  RESET
                </button>
              )}
            </div>

            {/* Filter inputs */}
            <div className="filter-options-container">
              {filterOptions
                ? headers
                    .filter((h) => !NON_FILTERABLE.has(h) && HEADER_TO_FILTER_KEY[h])
                    .map((header) => renderFilterInput(header))
                : (
                  <p style={{ padding: "16px", color: "#6A6A6A", fontSize: "13px" }}>
                    Loading filter options...
                  </p>
                )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StudentRegistrationTable;